var utils = require('./tripletrax.utils.js');
var initialize = require('./tripletrax.initialize.js');
var ajax = require('./tripletrax.ajax.js');
var changes = require('./tripletrax.changes.js');
var views = require('./tripletrax.views.js');

function registerReportsEvents() {

    Highcharts.setOptions({
        lang: {
            contextButtonTitle: trans('tripletrax.context_button_title'),
            decimalPoint: '.',
            downloadJPEG: trans('tripletrax.download_JPEG'),
            downloadPDF: trans('tripletrax.download_PDF'),
            downloadPNG: trans('tripletrax.download_PNG'),
            downloadSVG: trans('tripletrax.download_SVG'),
            drillUpText: trans('tripletrax.drill_up_text'),
            loading: trans('tripletrax.loading') + '...',
            months: [trans('tripletrax.january'), trans('tripletrax.february'), trans('tripletrax.march'), trans('tripletrax.april'), trans('tripletrax.may'), trans('tripletrax.june'), trans('tripletrax.july'), trans('tripletrax.august'), trans('tripletrax.september'), trans('tripletrax.october'), trans('tripletrax.november'), trans('tripletrax.december')],
            noData: trans('tripletrax.no_data'),
            numericSymbols: [ "k" , "M" , "G" , "T" , "P" , "E"],
            printChart: trans('tripletrax.print_chart'),
            resetZoom: trans('tripletrax.reset_zoom'),
            resetZoomTitle: trans('tripletrax.reset_zoom'),
            shortMonths: [trans('tripletrax.january_short'), trans('tripletrax.february_short'), trans('tripletrax.march_short'), trans('tripletrax.april_short'), trans('tripletrax.may_short'), trans('tripletrax.june_short'), trans('tripletrax.july_short'), trans('tripletrax.august_short'), trans('tripletrax.september_short'), trans('tripletrax.october_short'), trans('tripletrax.november_short'), trans('tripletrax.december_short')],
            thousandsSep: " ",
            weekdays: [trans('tripletrax.sunday'), trans('tripletrax.monday'), trans('tripletrax.tuesday'), trans('tripletrax.wednesday'), trans('tripletrax.thursday'), trans('tripletrax.friday'), trans('tripletrax.saturday')]
        },
        chart: {
            style: {
                fontFamily: "'Open Sans', Arial, Helvetica, sans-serif"
            }
        },
        exporting: {
            buttons: {
                contextButton: {
                    theme: {
                        display: 'none'
                    },
                    menuItems: [{
                        text: Lang.get('tripletrax.print_graph'),
                        onclick: function () {
                            this.print();
                        }
                    }, {
                        text: Lang.get('tripletrax.export_as_png'),
                        onclick: function () {
                            var width = this.chartWidth;
                            this.exportChart({
                                type: 'image/png'
                            }, {
                                chart: {
                                    width: width
                                }
                            });
                        },
                        separator: false
                    }, {
                        text: Lang.get('tripletrax.export_as_jpeg'),
                        onclick: function () {
                            var width = this.chartWidth;
                            this.exportChart({
                                type: 'image/jpeg'
                            }, {
                                chart: {
                                    width: width
                                }
                            });
                        },
                        separator: false
                    }, {
                        text: Lang.get('tripletrax.export_as_pdf'),
                        onclick: function () {
                            var width = this.chartWidth;
                            this.exportChart({
                                type: 'application/pdf'
                            }, {
                                chart: {
                                    width: width
                                }
                            });
                        },
                        separator: false
                    }, {
                        text: Lang.get('tripletrax.export_as_svg'),
                        onclick: function () {
                            var width = this.chartWidth;
                            this.exportChart({
                                type: 'image/svg+xml'
                            }, {
                                chart: {
                                    width: width
                                }
                            });
                        },
                        separator: false
                    }]
                }
            }
        }
    });

    (function (H) {
        var defaultPlotOptions = H.getOptions().plotOptions,
            columnType = H.seriesTypes.column;

        defaultPlotOptions.xrange = H.merge(defaultPlotOptions.column, {});
        H.seriesTypes.xrange = H.extendClass(columnType, {
            type: 'xrange',

            translate: function () {
                columnType.prototype.translate.apply(this, arguments);
                var series = this,
                    xAxis = series.xAxis,
                    yAxis = series.yAxis,
                    barHeight = series.options.height || 10,
                    barWidth;

                H.each(series.points, function (point) {
                    barWidth = xAxis.translate(H.pick(point.x2, point.x + (point.len || 0))) - point.plotX;
                    point.shapeArgs = {
                        x: point.plotX,
                        y: point.plotY - (barHeight / 2),
                        width: barWidth,
                        height: barHeight
                    };
                    point.tooltipPos[0] += barWidth / 2;
                    point.tooltipPos[1] -= barHeight / 2;
                });
            },
            generatePoints: function () {
                columnType.prototype.generatePoints.apply(this, arguments);
                var series = this,
                    xAxis = series.xAxis,
                    max = Number.MIN_VALUE,
                    pointX2;
                H.each(series.points, function (point) {
                    pointX2 = H.pick(point.x2, point.x + (point.len || 0));
                    if (pointX2 > max) {
                        max = pointX2;
                    }
                });
                if (max > xAxis.max) {
                    series.xAxis.setExtremes(xAxis.min, max);
                }
            }
        });
    }(Highcharts));

    // Auswahl Patienten Auswertungen - Anzeige der gewählten Auswertung
    $('body').on('change', '.tt-select-patient-report', function (e) {

        setChartPage();
    });

    // Auswahl Auswertungen - Anzeige der gewählten Auswertung
    $('body').on('change', '.tt-select-report,.tt-refresh-report,.tt-select-frozen-data', function (e) {

    	setFacilityChartPage();
    });

    $('body').on('change', '.tt-select-report-facility-attributes', function (e) {

		if (!utils.isUndefined(utils.GLOBALS.runningBenchDataRequest) && utils.GLOBALS.runningBenchDataRequest.state() === 'pending') {
			utils.GLOBALS.reloadBenchData = true;
		} else {
			utils.GLOBALS.runningBenchDataRequest = getBenchData();
		}
	});

    // Auswahl Patienten Auswertungen - Auswertung aktualisieren
    $('body').on('click', '.tt-refresh-patient-report', function (e) {

        setChartPage();
    });

    // Auswahl Auswertungen - Auswertung aktualisieren
    $('body').on('click', '.tt-refresh-report', function (e) {

        setFacilityChartPage();
    });

    $('body').on('click', '.tt-print-report,.tt-download-report-png', function (e) {
		e.preventDefault();

    	var buttonElement = $(this);
        $('.tt-please-wait-print').removeClass('hide');
        var graphList = ['fev1', 'height_weight_bmi', 'lufu' ,'height_weight' ,'bacteria'];
		var type = 'graph';
		if ($('.tt-patient-reports-tab').length) {
			var questionnaires = $('[name="questionnaire_types"]').val();
			questionnaires = $.parseJSON(questionnaires);
			$.each(questionnaires, function(key, questionnaire) {
				if ($('.tt-patient-reports-tab.active').find('[href="#'+key+'"]').length) {
					graphList.push(key);
				} else if ($('.tt-patient-reports-table-tab.active').find('[href="#table1_tab"]').length) {
					type = 'table';
				}
			});
		}
        if ($('.tt-facility-report-tab').length) {
            var selectedGraph = $('[name="graphic_type"]:checked').val();
            if (selectedGraph === 'age_distribution' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('age_distribution');
            } else if (selectedGraph === 'age_distribution' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('age_distribution_years');
            } else if (selectedGraph === 'lufu' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('lufu_facility');
            } else if (selectedGraph === 'lufu' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('lufu_facility_years');
            } else if (selectedGraph === 'lufu' && $('.tt-facility-report-tab.active').find('[href="#tab_graph3"]').length) {
				graphList.push('lufu_severity_years');
			}
            else if (selectedGraph === 'weight' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('weight_facility');
            } else if (selectedGraph === 'weight' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('weight_facility_years');
            } else if (selectedGraph === 'complications' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('complications_facility');
            } else if (selectedGraph === 'complications' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('complications_facility_years');
            } else if (selectedGraph === 'therapy' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('therapy_facility');
            } else if (selectedGraph === 'therapy' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('therapy_facility_years');
            } else if (selectedGraph === 'mibi' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('mibi_facility');
            } else if (selectedGraph === 'mibi' && $('.tt-facility-report-tab.active').find('[href="#tab_graph2"]').length) {
                graphList.push('mibi_facility_years');
            } else if (selectedGraph === 'patient_count' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) {
                graphList.push('patient_count_years');
            } else {
                type = 'table';
            }
        }

        $.each(graphList, function(i, graph) {
            if ($('#' + graph + '_canvas').length) {
                canvg(document.getElementById(graph + "_canvas"), $('<div>').append($('#' + graph + '_graph .highcharts-container svg').clone()).html());
                var img = document.getElementById(graph + "_canvas").toDataURL("image/png");
                $('#' + graph + '_canvas').append('<img src="' + img + '"/>');

                $('#' + graph + '_canvas').removeClass('hide');
                $('#' + graph + '_graph').addClass('hide');
            }
            if (graph !== 'fev1' && graph !== 'height_weight_bmi' && graph !== 'bacteria') {
                $('.tt-select-report-value-type').addClass('hide');
            }
        });

        var date = new Date();
        $('.tt-date-today').text(utils.dateToLocaleString(date));
        $('.tt-patient-name,.tt-facility-name,.tt-report-year').addClass('tt-patient-name-print');

        $('.alert-warning').addClass('hide');
        $('.radio').find('[type="radio"]').attr('type', 'checkbox');
        $('.radio').removeClass('radio').addClass('checkbox');

		$('#content-detail-reports-detail,#content-detail').addClass('background-color-white');

        html2canvas($('#content-detail-reports-detail,#content-detail'), {
            onrendered: function(canvas) {
                canvas.style.width = '100%';
                var image = canvas.toDataURL();

				$.each(graphList, function(i, graph) {
					if ($('#' + graph + '_canvas').length) {
						$('#' + graph + '_canvas').find('img').remove();
						$('#' + graph + '_canvas').addClass('hide');
						$('#' + graph + '_graph').removeClass('hide');
					}
					if (graph !== 'fev1' && graph !== 'height_weight_bmi' && graph !== 'bacteria') {
						$('.tt-select-report-value-type').removeClass('hide');
					}
				});

				$('.tt-date-today').text('');
				$('.tt-patient-name,.tt-facility-name,.tt-report-year').removeClass('tt-patient-name-print');
				$('.checkbox').find('[type="checkbox"]').attr('type', 'radio');
				$('.checkbox').removeClass('checkbox').addClass('radio');
				$('#content-detail-reports-detail,#content-detail').removeClass('background-color-white');

                if (buttonElement.hasClass('tt-download-report-png')) {

					var a = $('<a>').attr('href', image)
						.attr('download', 'report.png')
						.appendTo('body');
					a[0].click();
					a.remove();

					$('.tt-please-wait-print').addClass('hide');

				} else {

					var timestamp = $.now();

					ajax.ajaxCall('doc/patient/reports/print', 'POST', '&canvas=' + image + '&timestamp=' + timestamp + '&width=' + canvas.width + '&height=' + canvas.height + '&type=' + type, false, function (data) {

						ajax.ajaxCall('doc/patient/reports/check/' + timestamp, 'GET', null, false, function (data) {

							if (data === 'not_existing') {
								$.SmartMessageBox({
									title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_report_file'),
									content: Lang.get('tripletrax.not_existing_report_file_desc'),
									buttons: '[' + Lang.get('tripletrax.ok') + ']'
								}, function (ButtonPressed) {
								});
							} else {
								var originalFilename = 'report';
								if ($('[name="report_title"]').length) {
									originalFilename = $('[name="report_title"]').val();
								}

								// Datei herunterladen
								window.open('doc/patient/reports/download/' + data + '/' + encodeURI(originalFilename), '_blank');

								// Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
								setTimeout(function () {
									ajax.ajaxCall('doc/patient/reports/delete/' + data, 'POST', null, false, function (data) {
									});
								}, 100);
							}

							$('.tt-please-wait-print').addClass('hide');
						});
					});
				}
            }
        });
    });

    $('body').on('click', '.tt-report-reset-button', function (e) {
        var chart = $(this).parents('.tt-chart,.tt-full-chart,.tt-chart-facility-report,.tt-chart-facility-legend-report').highcharts();
        chart.zoomOut();
    });

    $('body').on('click', '.tt-report-print-button', function (e) {
        $($(this).parents('.tt-chart,.tt-full-chart,.tt-chart-facility-report,.tt-chart-facility-legend-report').find('.highcharts-button')[0]).click()
    });

    $('body').on('click', '[name="lufu_value_type"]', function (e) {

        $('#lufu_graph').empty();
        addLufuGraph();
    });

    $('body').on('click', '[name="height_weight_value_type"]', function (e) {

        $('#height_weight_graph').empty();
        addHeightWeightGraph();
    });

    $('body').on('change', '[name="graphic_type"]', function (e) {
        e.preventDefault();

        var selectedGraph = $('[name="graphic_type"]:checked').val();

        $('.tt-report-graphs').find('.row').addClass('hide');
        $('.tt-report-tables').find('table').addClass('hide');
        if (selectedGraph === 'age_distribution') {
            $('.tt-age-report,.tt-age-table').removeClass('hide');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-age-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-age-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-age-table');

            $('[href="#tab_graph1"]').text(trans('tripletrax.age_distribution'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.age_distribution_years'));

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
            $('[href="#tab_table1"]').parent().addClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
            $('[href="#tab_table3"]').parent().addClass('hide');
            if ($('[href="#tab_table1"]').parent().hasClass('active') || $('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
                $('[href="#tab_graph1"]').tab('show');
            }
        } else if (selectedGraph === 'lufu') {
            $('.tt-lufu-report,.tt-lufu-table,.tt-fev1-years-table,.tt-fev1-severity-table').removeClass('hide');
            $('#tab_table1 .tt-export-csv').data('tableClass', 'tt-lufu-table');
            $('#tab_table1 .tt-export-excel').data('tableClass', 'tt-lufu-table');
            $('#tab_table1 .tt-export-pdf').data('tableClass', 'tt-lufu-table');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-fev1-years-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-fev1-years-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-fev1-years-table');
			$('#tab_table3 .tt-export-csv').data('tableClass', 'tt-fev1-severity-table');
			$('#tab_table3 .tt-export-excel').data('tableClass', 'tt-fev1-severity-table');
			$('#tab_table3 .tt-export-pdf').data('tableClass', 'tt-fev1-severity-table');

            $('[href="#tab_graph1"]').text(trans('tripletrax.lufu'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.lufu_years'));
            $('[href="#tab_graph3"]').text(trans('tripletrax.severity_fev1'));

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().removeClass('hide');
            $('[href="#tab_table1"]').parent().removeClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().removeClass('hide');
        } else if (selectedGraph === 'weight') {
            $('.tt-weight-report,.tt-weight-table,.tt-weight-years-table').removeClass('hide');
            $('#tab_table1 .tt-export-csv').data('tableClass', 'tt-weight-table');
            $('#tab_table1 .tt-export-excel').data('tableClass', 'tt-weight-table');
            $('#tab_table1 .tt-export-pdf').data('tableClass', 'tt-weight-table');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-weight-years-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-weight-years-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-weight-years-table');

            $('[href="#tab_graph1"]').text(trans('tripletrax.weight_report'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.weight_years'));

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
			$('[href="#tab_table1"]').parent().removeClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().addClass('hide');
			if ($('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
				$('[href="#tab_graph1"]').tab('show');
			}
        } else if (selectedGraph === 'complications') {
            $('.tt-complications-report,.tt-complications-table,.tt-complications-years-table').removeClass('hide');
            $('#tab_table1 .tt-export-csv').data('tableClass', 'tt-complications-table');
            $('#tab_table1 .tt-export-excel').data('tableClass', 'tt-complications-table');
            $('#tab_table1 .tt-export-pdf').data('tableClass', 'tt-complications-table');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-complications-years-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-complications-years-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-complications-years-table');

            $('[href="#tab_graph1"]').text(trans('tripletrax.complications'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.complications_years'));

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
			$('[href="#tab_table1"]').parent().removeClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().addClass('hide');
			if ($('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
				$('[href="#tab_graph1"]').tab('show');
			}
        } else if (selectedGraph === 'therapy') {
            $('.tt-therapy-report,.tt-therapy-table,.tt-therapy-years-table').removeClass('hide');
            $('#tab_table1 .tt-export-csv').data('tableClass', 'tt-therapy-table');
            $('#tab_table1 .tt-export-excel').data('tableClass', 'tt-therapy-table');
            $('#tab_table1 .tt-export-pdf').data('tableClass', 'tt-therapy-table');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-therapy-years-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-therapy-years-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-therapy-years-table');

            $('[href="#tab_graph1"]').text(trans('tripletrax.therapy'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.therapy_years'));

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
			$('[href="#tab_table1"]').parent().removeClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().addClass('hide');
			if ($('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
				$('[href="#tab_graph1"]').tab('show');
			}
        } else if (selectedGraph === 'mibi') {
            $('.tt-mibi-report,.tt-mibi-table,.tt-mibi-years-table').removeClass('hide');
            $('[href="#tab_graph1"]').text(trans('tripletrax.mibi'));
            $('[href="#tab_graph2"]').text(trans('tripletrax.mibi_years'));

            $('#tab_table1 .tt-export-csv').data('tableClass', 'tt-mibi-table');
            $('#tab_table1 .tt-export-excel').data('tableClass', 'tt-mibi-table');
            $('#tab_table1 .tt-export-pdf').data('tableClass', 'tt-mibi-table');
            $('#tab_table2 .tt-export-csv').data('tableClass', 'tt-mibi-years-table');
            $('#tab_table2 .tt-export-excel').data('tableClass', 'tt-mibi-years-table');
            $('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-mibi-years-table');

            $('[href="#tab_graph2"]').parent().removeClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
			$('[href="#tab_table1"]').parent().removeClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().addClass('hide');
			if ($('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
				$('[href="#tab_graph1"]').tab('show');
			}
        } else if (selectedGraph === 'patient_count') {
            $('.tt-patient-count-report, .tt-patient-count-years-table').removeClass('hide');

            $('[href="#tab_graph1"]').text(trans('tripletrax.patient_distribution'));

			$('#tab_table2 .tt-export-csv').data('tableClass', 'tt-patient-count-years-table');
			$('#tab_table2 .tt-export-excel').data('tableClass', 'tt-patient-count-years-table');
			$('#tab_table2 .tt-export-pdf').data('tableClass', 'tt-patient-count-years-table');

            $('[href="#tab_graph2"]').parent().addClass('hide');
			$('[href="#tab_graph3"]').parent().addClass('hide');
			$('[href="#tab_table1"]').parent().addClass('hide');
            $('[href="#tab_table2"]').parent().removeClass('hide');
			$('[href="#tab_table3"]').parent().addClass('hide');

			if ($('[href="#tab_graph2"]').parent().hasClass('active') || $('[href="#tab_table1"]').parent().hasClass('active') || $('[href="#tab_graph3"]').parent().hasClass('active') || $('[href="#tab_table3"]').parent().hasClass('active')){
				$('[href="#tab_graph1"]').tab('show');
			}

        }

        setAdditionalSelection();
        reflowCharts();
    });

    $('body').on('change', '[name="patients_age"],[name="gender"],[name="display"]', function (e) {
        e.preventDefault();

        var selectedAge = $('[name="patients_age"]:checked').val();
        var selectedGender = $('[name="gender"]:checked').val();
        var display = $('[name="display"]:checked').val();
		var selectedReport = $('[name="report_type"]:selected').val();

        var chart_age = $('#age_distribution_graph').highcharts();
        var chart_age_years = $('#age_distribution_years_graph').highcharts();
        var table_age = $('.tt-age-table');
        var chart_count_years = $('#patient_count_years_graph').highcharts();
        var table_count_years = $('.tt-patient-count-years-table');

        var chart_lufu = $('#lufu_facility_graph').highcharts();
        var chart_lufu_bench =  $('#lufu_facility_bench_graph').highcharts();
        var chart_lufu_years = $('#lufu_facility_years_graph').highcharts();
		var chart_lufu_years_bench = $('#lufu_facility_years_bench_graph').highcharts();
        var chart_lufu_severity = $('#lufu_severity_years_graph').highcharts();
        var chart_lufu_severity_bench = $('#lufu_severity_years_bench_graph').highcharts();
        var table_lufu = $('.tt-lufu-table');
        var table_years_lufu = $('.tt-fev1-years-table');
        var table_fev1_severity = $('.tt-fev1-severity-table');

        var chart_weight = $('#weight_facility_graph').highcharts();
		var chart_weight_bench = $('#weight_facility_bench_graph').highcharts();
        var chart_weight_years = $('#weight_facility_years_graph').highcharts();
		var chart_weight_years_bench = $('#weight_facility_years_bench_graph').highcharts();
        var table_weight = $('.tt-weight-table');
        var table_years_weight = $('.tt-weight-years-table');

        var chart_complications = $('#complications_facility_graph').highcharts();
        var chart_complications_years = $('#complications_facility_years_graph').highcharts();
        var table_complications = $('.tt-complications-table,.tt-therapy-table,.tt-mibi-table');
        var table_years_complications = $('.tt-complications-years-table,.tt-therapy-years-table,.tt-mibi-years-table');

        var chart_therapy = $('#therapy_facility_graph').highcharts();
        var chart_therapy_years = $('#therapy_facility_years_graph').highcharts();

        var chart_mibi = $('#mibi_facility_graph').highcharts();
		var chart_mibi_bench = $('#mibi_facility_bench_graph').highcharts();
        var chart_mibi_years = $('#mibi_facility_years_graph').highcharts();
		var chart_mibi_years_bench = $('#mibi_facility_years_bench_graph').highcharts();

        var data_table_variable = '';
        var data_table_variable_percent = '';

        var data_variable = 'values';
        var data_variable_percent = 'values';
        var data_bench_variable = 'bench-values';
        var age_variable = '';
        var age_table_variable = '.tt-all-ages';
		var patient_number = 0;

	if (selectedAge === 'infants' || selectedAge === 'children' || selectedAge === 'adults') {
			age_variable = '-' + selectedAge;
			age_table_variable = '.tt-' + selectedAge;
		}
		if (selectedGender === 'male') {
			data_variable = 'values-male' + age_variable;
			data_bench_variable = 'bench-values-male' + age_variable;
			if (display === 'absolut') {
				data_variable_percent = 'values-male' + age_variable;
				data_table_variable_percent = '.tt-absolut' + age_table_variable + '.tt-male';
			} else {
				data_variable_percent = 'values-male' + age_variable + '-percent';
				data_table_variable_percent = '.tt-percent' + age_table_variable + '.tt-male';
			}
			data_table_variable = age_table_variable + '.tt-male';
		} else if (selectedGender === 'female') {
			data_variable = 'values-female' + age_variable;
			data_bench_variable = 'bench-values-female' + age_variable;
			if (display === 'absolut') {
				data_variable_percent = 'values-female' + age_variable;
				data_table_variable_percent = '.tt-absolut' + age_table_variable + '.tt-female';
			} else {
				data_variable_percent = 'values-female' + age_variable + '-percent';
				data_table_variable_percent = '.tt-percent' + age_table_variable + '.tt-female';
			}
			data_table_variable = age_table_variable + '.tt-female';
		} else {
			data_variable = 'values' + age_variable;
			data_bench_variable = 'bench-values' + age_variable;

			if (display === 'absolut') {
				data_variable_percent = 'values' + age_variable;
				data_table_variable_percent = '.tt-absolut' + age_table_variable + '.tt-all-gender';
			} else {
				data_variable_percent = 'values' + age_variable + '-percent';
				data_table_variable_percent = '.tt-percent' + age_table_variable + '.tt-all-gender';
			}

			data_table_variable = age_table_variable + '.tt-all-gender';
		}

		if (selectedReport === 'doc/reports/facility_report' || selectedReport === 'admin/reports/facility_report') {

			var data_age = $('#age_distribution_graph').data(data_variable_percent);
			var data_age_years = $('#age_distribution_years_graph').data(data_variable);
			var data_age_years_patient_numbers = getSeriesIntegerData($('#age_distribution_years_graph_number_patients').data(data_variable));
			var data_median_age_years = [];
			for (var i = 0; i < data_age_years.length; i++) {
				data_median_age_years.push([data_age_years[i][0], data_age_years[i][3]]);
			}

			var data_count_years = getSeriesIntegerData($('#patient_count_years_graph').data(data_variable));

			var data_lufu = null;
			var data_lufu_patient_numbers = null;
			var data_median_lufu = [];
			var data_lufu_years = null;
			var data_lufu_years_patient_numbers = null;
			var data_median_lufu_years = [];
			var data_lufu_severity = null;

			if (selectedAge !== 'infants') {
				data_lufu = $('#lufu_facility_graph').data(data_variable);
				data_lufu_patient_numbers = $('#lufu_facility_graph_number_patients').data(data_variable);
				for (var j = 0; j < data_lufu.length; j++) {
					data_median_lufu.push([data_lufu[j][2]]);
				}
				data_lufu_years = $('#lufu_facility_years_graph').data(data_variable);
				data_lufu_years_patient_numbers = $('#lufu_facility_years_graph_number_patients').data(data_variable);
				for (var k = 0; k < data_lufu_years.length; k++) {
					data_median_lufu_years.push([data_lufu_years[k][0], data_lufu_years[k][3]]);
				}

				data_lufu_severity = $('#lufu_severity_years_graph').data(data_variable);
			}

			var data_weight = $('#weight_facility_graph').data(data_variable);
			var data_weight_patient_numbers = $('#weight_facility_graph_number_patients').data(data_variable);
			var data_median_weight = [];
			for (var l = 0; l < data_weight.length; l++) {
				data_median_weight.push(data_weight[l][2]);
			}
			var data_weight_years = $('#weight_facility_years_graph').data(data_variable);
			var data_weight_years_patient_numbers = $('#weight_facility_years_graph_number_patients').data(data_variable);
			var data_median_weight_years = [];
			for (var m = 0; m < data_weight_years.length; m++) {
				data_median_weight_years.push([data_weight_years[m][0], parseFloat(data_weight_years[m][3].toString())]);
			}

			var data_complications = $('#complications_facility_graph').data(data_variable_percent);
			var data_complications_years = $('#complications_facility_years_graph').data(data_variable_percent);

			var data_therapy = $('#therapy_facility_graph').data(data_variable_percent);
			var data_therapy_years = $('#therapy_facility_years_graph').data(data_variable_percent);

			var data_mibi = $('#mibi_facility_graph').data(data_variable_percent);
			var data_mibi_years = $('#mibi_facility_years_graph').data(data_variable_percent);


			$('.tt-report-table-row,.tt-additional-header').addClass('hide');
			table_age.find(data_table_variable).removeClass('hide');
			table_lufu.find(data_table_variable).removeClass('hide');
			table_years_lufu.find(data_table_variable).removeClass('hide');
			table_fev1_severity.find(data_table_variable).removeClass('hide');
			table_weight.find(data_table_variable).removeClass('hide');
			table_count_years.find(data_table_variable).removeClass('hide');
			table_years_weight.find(data_table_variable).removeClass('hide');
			table_complications.find(data_table_variable_percent).removeClass('hide');
			table_years_complications.find(data_table_variable_percent).removeClass('hide');

			if (display === 'absolut') {
				chart_age.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_complications.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_complications_years.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_therapy.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_therapy_years.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_mibi.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});
				chart_mibi_years.yAxis[0].setTitle({text: trans('tripletrax.number_of_patients')});

			} else if (display === 'percent') {
				chart_age.yAxis[0].setTitle({text: '%'});
				chart_complications.yAxis[0].setTitle({text: '%'});
				chart_complications_years.yAxis[0].setTitle({text: '%'});
				chart_therapy.yAxis[0].setTitle({text: '%'});
				chart_therapy_years.yAxis[0].setTitle({text: '%'});
				chart_mibi.yAxis[0].setTitle({text: '%'});
				chart_mibi_years.yAxis[0].setTitle({text: '%'});
			}

			if (selectedAge === 'infants') {

				chart_age.xAxis[0].setCategories(['0-1']);
				chart_age.setTitle({text: trans('tripletrax.age_distribution_infants')});
				chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_infants')});
				chart_weight.xAxis[0].setCategories(['0-1']);
				chart_weight.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight.series[0].update({name: trans('tripletrax.lsg_percentile')});
				chart_weight.setTitle({text: trans('tripletrax.weight_report_infants')});
				chart_weight_years.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight_years.series[0].update({name: trans('tripletrax.lsg_percentile')});
				chart_weight_years.setTitle({text: trans('tripletrax.weight_years_infants')});
				chart_complications.xAxis[0].setCategories(['0-1']);
				chart_complications.setTitle({text: trans('tripletrax.complications_infants')});
				chart_complications_years.setTitle({text: trans('tripletrax.complications_years_infants')});
				chart_therapy.xAxis[0].setCategories(['0-1']);
				chart_therapy.setTitle({text: trans('tripletrax.therapy_infants')});
				chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_infants')});
				chart_mibi.xAxis[0].setCategories(['0-1']);
				chart_mibi.setTitle({text: trans('tripletrax.mibi_infants')});
				chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_infants')});
				chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_infants')});

				if (selectedGender === 'male') {
					chart_age.setTitle({text: trans('tripletrax.age_distribution_infants_male')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_infants_male')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_infants_male')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_infants_male')});
					chart_complications.setTitle({text: trans('tripletrax.complications_infants_male')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_infants_male')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_infants_male')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_infants_male')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_infants_male')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_infants_male')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_infants_male')});

				} else if (selectedGender === 'female') {

					chart_age.setTitle({text: trans('tripletrax.age_distribution_infants_female')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_infants_female')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_infants_female')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_infants_female')});
					chart_complications.setTitle({text: trans('tripletrax.complications_infants_female')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_infants_female')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_infants_female')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_infants_female')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_infants_female')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_infants_female')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_infants_female')});

				}
			} else if (selectedAge === 'children') {

				chart_age.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17']);
				chart_age.setTitle({text: trans('tripletrax.age_distribution_children')});
				chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_children')});
				chart_lufu.xAxis[0].setCategories(['6-11', '12-17']);
				chart_lufu.setTitle({text: trans('tripletrax.lufu_children')});
				chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_children')});
				chart_lufu_severity.xAxis[0].setCategories(['6-11', '12-17']);
				chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_children')});
				chart_weight.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17']);
				chart_weight.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
				chart_weight.series[0].update({name: trans('tripletrax.bmi_percentile')});
				chart_weight.setTitle({text: trans('tripletrax.weight_report_children')});
				chart_weight_years.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
				chart_weight_years.series[0].update({name: trans('tripletrax.bmi_percentile')});
				chart_weight_years.setTitle({text: trans('tripletrax.weight_years_children')});
				chart_complications.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17']);
				chart_complications.setTitle({text: trans('tripletrax.complications_children')});
				chart_complications_years.setTitle({text: trans('tripletrax.complications_years_children')});
				chart_therapy.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17']);
				chart_therapy.setTitle({text: trans('tripletrax.therapy_children')});
				chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_children')});
				chart_mibi.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17']);
				chart_mibi.setTitle({text: trans('tripletrax.mibi_children')});
				chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_children')});
				chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_children')});

				if (selectedGender === 'male')
				{
					chart_age.setTitle({text: trans('tripletrax.age_distribution_children_male')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_children_male')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_children_male')});
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_children_male')});
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_children_male')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_children_male')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_children_male')});
					chart_complications.setTitle({text: trans('tripletrax.complications_children_male')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_children_male')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_children_male')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_children_male')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_children_male')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_children_male')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_children_male')});

				} else if (selectedGender === 'female') {

					chart_age.setTitle({text: trans('tripletrax.age_distribution_children_female')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_children_female')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_children_female')});
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_children_female')});
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_children_female')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_children_female')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_children_female')});
					chart_complications.setTitle({text: trans('tripletrax.complications_children_female')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_children_female')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_children_female')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_children_female')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_children_female')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_children_female')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_children_female')});

				}
			} else if (selectedAge === 'adults') {

				chart_age.xAxis[0].setCategories(['18‐29', '30‐39', '40‐49', '>= 50']);
				chart_age.setTitle({text: trans('tripletrax.age_distribution_adults')});
				chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_adults')});
				chart_lufu.xAxis[0].setCategories(['18-29', '30-39', '40-49', '>= 50']);
				chart_lufu.setTitle({text: trans('tripletrax.lufu_adults')});
				chart_lufu_severity.xAxis[0].setCategories(['18-29', '30-39', '40-49','>= 50']);
				chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_adults')});
				chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_adults')});
				chart_weight.xAxis[0].setCategories(['18-29', '30-39', '40-49', '>= 50']);
				chart_weight.yAxis[0].setTitle({text: trans('tripletrax.bmi')});
				chart_weight.series[0].update({name: trans('tripletrax.bmi')});
				chart_weight.setTitle({text: trans('tripletrax.weight_report_adults')});
				chart_weight_years.yAxis[0].setTitle({text: trans('tripletrax.bmi')});
				chart_weight_years.series[0].update({name: trans('tripletrax.bmi')});
				chart_weight_years.setTitle({text: trans('tripletrax.weight_years_adults')});
				chart_complications.xAxis[0].setCategories(['18‐29', '30‐39', '40‐49', '>= 50']);
				chart_complications.setTitle({text: trans('tripletrax.complications_adults')});
				chart_complications_years.setTitle({text: trans('tripletrax.complications_years_adults')});
				chart_therapy.xAxis[0].setCategories(['18‐29', '30‐39', '40‐49', '>= 50']);
				chart_therapy.setTitle({text: trans('tripletrax.therapy_adults')});
				chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_adults')});
				chart_mibi.xAxis[0].setCategories(['18‐29', '30‐39', '40‐49', '>= 50']);
				chart_mibi.setTitle({text: trans('tripletrax.mibi_adults')});
				chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_adults')});
				chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_adults')});

				if(selectedGender === 'male')
				{
					chart_age.setTitle({text: trans('tripletrax.age_distribution_adults_male')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_adults_male')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_adults_male')});
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_adults_male')});
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_adults_male')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_adults_male')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_adults_male')});
					chart_complications.setTitle({text: trans('tripletrax.complications_adults_male')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_adults_male')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_adults_male')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_adults_male')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_adults_male')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_adults_male')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_adults_male')});

				}else if(selectedGender === 'female')
				{
					chart_age.setTitle({text: trans('tripletrax.age_distribution_adults_female')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_adults_female')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_adults_female')});
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_adults_female')});
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_adults_female')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_adults_female')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_adults_female')});
					chart_complications.setTitle({text: trans('tripletrax.complications_adults_female')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_adults_female')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_adults_female')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_adults_female')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_adults_female')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_adults_female')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_adults_female')});

				}
			} else {
				if (selectedGender === 'male') {
					chart_age.setTitle({text: trans('tripletrax.age_distribution_male')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_male')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_male')});
					chart_lufu.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_male')});
					chart_lufu_severity.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_male')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_male')});
					chart_weight.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_male')});
					chart_complications.setTitle({text: trans('tripletrax.complications_male')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_male')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_male')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_male')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_male')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_male')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_male')});

				} else if (selectedGender === 'female') {
					chart_age.setTitle({text: trans('tripletrax.age_distribution_female')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years_female')});
					chart_lufu.setTitle({text: trans('tripletrax.lufu_female')});
					chart_lufu.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years_female')});
					chart_lufu_severity.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1_female')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report_female')});
					chart_weight.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years_female')});
					chart_complications.setTitle({text: trans('tripletrax.complications_female')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years_female')});
					chart_therapy.setTitle({text: trans('tripletrax.therapy_female')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years_female')});
					chart_mibi.setTitle({text: trans('tripletrax.mibi_female')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years_female')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution_female')});
				} else {
					chart_age.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_age.setTitle({text: trans('tripletrax.age_distribution')});
					chart_age_years.setTitle({text: trans('tripletrax.age_distribution_years')});
					chart_lufu.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu.setTitle({text: trans('tripletrax.lufu')});
					chart_lufu_severity.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_lufu_severity.setTitle({text: trans('tripletrax.severity_fev1')});
					chart_lufu_years.setTitle({text: trans('tripletrax.lufu_years')});
					chart_weight.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
					chart_weight.series[0].update({name: trans('tripletrax.bmi_percentile')});
					chart_weight.setTitle({text: trans('tripletrax.weight_report')});
					chart_weight_years.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
					chart_weight_years.series[0].update({name: trans('tripletrax.bmi_percentile')});
					chart_weight_years.setTitle({text: trans('tripletrax.weight_years')});
					chart_complications.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_complications.setTitle({text: trans('tripletrax.complications')});
					chart_complications_years.setTitle({text: trans('tripletrax.complications_years')});
					chart_therapy.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_therapy.setTitle({text: trans('tripletrax.therapy')});
					chart_therapy_years.setTitle({text: trans('tripletrax.therapy_years')});
					chart_mibi.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_mibi.setTitle({text: trans('tripletrax.mibi')});
					chart_mibi_years.setTitle({text: trans('tripletrax.mibi_years')});
					chart_count_years.setTitle({text: trans('tripletrax.patient_distribution')});
				}

			}

			chart_age.series[0].setData($.extend([], data_age), false, true, false);
			chart_age.redraw();
			chart_age_years.series[0].setData($.extend([], data_age_years), false, true, false);
			chart_age_years.series[0].update({

				tooltip: {
					shared: true,
					pointFormatter: function () {

						for (var i = 0; i < data_age_years_patient_numbers[0].length; i++) {
							if (data_age_years_patient_numbers[0][i][0] === this.x) {
								patient_number = data_age_years_patient_numbers[0][i][1];
							}

						}

						return '<span style="color:' +
							this.series.color + '">\u25CF</span> <b> ' +
							this.series.name + '</b><br/>' +
							trans('tripletrax.max') + ': ' + this.high + '<br/>' +
							trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
							trans('tripletrax.median') + ': ' + this.median + '<br/>' +
							trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
							trans('tripletrax.min') + ': ' + this.low + '<br/>' +
							trans('tripletrax.patient_number')+ ': ' + patient_number;
					}

				}
			});
			chart_age_years.series[1].setData($.extend([], data_median_age_years), false, true, false);

			chart_age_years.redraw();
			chart_count_years.series[0].setData(data_count_years[0], false, true, false);
			chart_count_years.redraw();

			if (selectedAge !== 'infants') {
				$('[name="graphic_type"][value="lufu"]').prop('disabled', false);
				$('[name="graphic_type"][value="lufu"]').parent().removeClass('disabled');
				chart_lufu.series[0].setData($.extend([], data_lufu), false, true, false);
				chart_lufu.series[0].update({

					tooltip: {
						shared: true,
						pointFormatter: function () {

							for (var key in data_lufu_patient_numbers) {
								if (key === this.category) {
									patient_number = data_lufu_patient_numbers[key][0];
								}
							}

							return '<span style="color:' +
								this.series.color + '">\u25CF</span> <b> ' +
								this.series.name + '</b><br/>' +
								trans('tripletrax.max') + ': ' + this.high + '<br/>' +
								trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
								trans('tripletrax.median') + ': ' + this.median + '<br/>' +
								trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
								trans('tripletrax.min') + ': ' + this.low + '<br/>' +
								trans('tripletrax.patient_number') + ': ' + patient_number;
						}

					}
				});
				chart_lufu.series[1].setData($.extend([], data_median_lufu), false, true, false);
				chart_lufu.redraw();
				chart_lufu_years.series[0].setData($.extend([], data_lufu_years), false, true, false);
				chart_lufu_years.series[0].update({

					tooltip: {
						shared: true,
						pointFormatter: function () {

							for (var key in data_lufu_years_patient_numbers) {
								if (parseInt(key) === this.x) {
									patient_number = data_lufu_years_patient_numbers[key][0];
								}
							}

							return '<span style="color:' +
								this.series.color + '">\u25CF</span> <b> ' +
								this.series.name + '</b><br/>' +
								trans('tripletrax.max') + ': ' + this.high + '<br/>' +
								trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
								trans('tripletrax.median') + ': ' + this.median + '<br/>' +
								trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
								trans('tripletrax.min') + ': ' + this.low + '<br/>' +
								trans('tripletrax.patient_number') + ': ' + patient_number;
						}

					}

				});
				chart_lufu_years.series[1].setData($.extend([], data_median_lufu_years), false, true, false);
				chart_lufu_years.redraw();

				chart_lufu_severity.series[0].setData($.extend([], data_lufu_severity[2][0]), false, true, false);
				chart_lufu_severity.series[1].setData($.extend([], data_lufu_severity[1][0]), false, true, false);
				chart_lufu_severity.series[2].setData($.extend([], data_lufu_severity[0][0]), false, true, false);
				chart_lufu_severity.series[0].update({composition: $.extend([], data_lufu_severity[2][1])});
				chart_lufu_severity.series[1].update({composition: $.extend([], data_lufu_severity[1][1])});
				chart_lufu_severity.series[2].update({composition: $.extend([], data_lufu_severity[0][1])});
				chart_lufu_severity.redraw();
			} else {
				$('[name="graphic_type"][value="lufu"]').prop('disabled', 'disabled');
				$('[name="graphic_type"][value="lufu"]').parent().addClass('disabled');
			}

			chart_weight.series[0].setData($.extend([], data_weight), false, true, false);
			chart_weight.series[0].update({

				tooltip: {
					shared: true,
					pointFormatter: function () {

						for(var key in data_weight_patient_numbers)
						{
							if(key === this.category)
							{
								patient_number = data_weight_patient_numbers[key][0];
							}
						}

						return '<span style="color:' +
							this.series.color + '">\u25CF</span> <b> ' +
							this.series.name + '</b><br/>' +
							trans('tripletrax.max') + ': ' + this.high + '<br/>' +
							trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
							trans('tripletrax.median') + ': ' + this.median + '<br/>' +
							trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
							trans('tripletrax.min') + ': ' + this.low + '<br/>' +
							trans('tripletrax.patient_number')+ ': ' + patient_number;
					}

				}
			});
			chart_weight.series[1].setData($.extend([], data_median_weight), false, true, false);
			chart_weight.redraw();
			chart_weight_years.series[0].setData($.extend([], data_weight_years), false, true, false);
			chart_weight_years.series[0].update({

				tooltip: {
					shared: true,
					pointFormatter: function () {

						for(var key in data_weight_years_patient_numbers)
						{
							if(parseInt(key) === this.x)
							{
								patient_number = data_weight_years_patient_numbers[key][0];
							}
						}

						return '<span style="color:' +
							this.series.color + '">\u25CF</span> <b> ' +
							this.series.name + '</b><br/>' +
							trans('tripletrax.max') + ': ' + this.high + '<br/>' +
							trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
							trans('tripletrax.median') + ': ' + this.median + '<br/>' +
							trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
							trans('tripletrax.min') + ': ' + this.low + '<br/>' +
							trans('tripletrax.patient_number')+ ': ' + patient_number;
					}

				}

			});
			chart_weight_years.series[1].setData($.extend([], data_median_weight_years), false, true, false);
			chart_weight_years.redraw();

			chart_complications.series[0].setData($.extend([], data_complications[3]), false, true, false);
			chart_complications.series[1].setData($.extend([], data_complications[2]), false, true, false);
			chart_complications.series[2].setData($.extend([], data_complications[1]), false, true, false);
			chart_complications.series[3].setData($.extend([], data_complications[0]), false, true, false);
			chart_complications.redraw();
			chart_complications_years.series[0].setData($.extend([], data_complications_years[3]), false, true, false);
			chart_complications_years.series[1].setData($.extend([], data_complications_years[2]), false, true, false);
			chart_complications_years.series[2].setData($.extend([], data_complications_years[1]), false, true, false);
			chart_complications_years.series[3].setData($.extend([], data_complications_years[0]), false, true, false);
			chart_complications_years.redraw();

			chart_therapy.series[0].setData($.extend([], data_therapy[2]), false, true, false);
			chart_therapy.series[1].setData($.extend([], data_therapy[1]), false, true, false);
			chart_therapy.series[2].setData($.extend([], data_therapy[0]), false, true, false);
			chart_therapy.redraw();
			chart_therapy_years.series[0].setData($.extend([], data_therapy_years[2]), false, true, false);
			chart_therapy_years.series[1].setData($.extend([], data_therapy_years[1]), false, true, false);
			chart_therapy_years.series[2].setData($.extend([], data_therapy_years[0]), false, true, false);
			chart_therapy_years.redraw();

			chart_mibi.series[0].setData($.extend([], data_mibi[7]), false, true, false);
			chart_mibi.series[1].setData($.extend([], data_mibi[6]), false, true, false);
			chart_mibi.series[2].setData($.extend([], data_mibi[5]), false, true, false);
			chart_mibi.series[3].setData($.extend([], data_mibi[4]), false, true, false);
			chart_mibi.series[4].setData($.extend([], data_mibi[3]), false, true, false);
			chart_mibi.series[5].setData($.extend([], data_mibi[2]), false, true, false);
			chart_mibi.series[6].setData($.extend([], data_mibi[1]), false, true, false);
			chart_mibi.series[7].setData($.extend([], data_mibi[0]), false, true, false);
			chart_mibi.redraw();
			chart_mibi_years.series[0].setData($.extend([], data_mibi_years[7]), false, true, false);
			chart_mibi_years.series[1].setData($.extend([], data_mibi_years[6]), false, true, false);
			chart_mibi_years.series[2].setData($.extend([], data_mibi_years[5]), false, true, false);
			chart_mibi_years.series[3].setData($.extend([], data_mibi_years[4]), false, true, false);
			chart_mibi_years.series[4].setData($.extend([], data_mibi_years[3]), false, true, false);
			chart_mibi_years.series[5].setData($.extend([], data_mibi_years[2]), false, true, false);
			chart_mibi_years.series[6].setData($.extend([], data_mibi_years[1]), false, true, false);
			chart_mibi_years.series[7].setData($.extend([], data_mibi_years[0]), false, true, false);
			chart_mibi_years.redraw();

		} else {

			if (selectedAge === 'infants') {

				chart_weight_bench.xAxis[0].setCategories(['0-1']);
				chart_weight_bench.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight_bench.series[0].update({name: trans('tripletrax.lsg_percentile')});
				chart_weight_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
				chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_infants')});
				chart_weight_years_bench.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight_years_bench.series[0].update({name: trans('tripletrax.lsg_percentile')});
				chart_weight_years_bench.series[1].update({name: trans('tripletrax.lsg_percentile_bench')});
				chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_infants')});
				chart_mibi_bench.xAxis[0].setCategories(['0-1']);
				chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_infants')});
				chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_infants')});

				if (selectedGender === 'male') {

					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_infants_male')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_infants_male')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_infants_male')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_infants_male')});

				} else if (selectedGender === 'female') {

					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_infants_female')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_infants_female')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_infants_female')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_infants_female')});

				}

			} else if (selectedAge === 'children') {

				chart_weight_bench.xAxis[0].setCategories(['0-1']);
				chart_weight_bench.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight_bench.series[0].update({name: trans('tripletrax.lsg_percentile')});
				chart_weight_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
				chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_children')});
				chart_weight_years_bench.yAxis[0].setTitle({text: trans('tripletrax.lsg_percentile')});
				chart_weight_years_bench.series[0].update({name: trans('tripletraxlsg_percentile')});
				chart_weight_years_bench.series[1].update({name: trans('tripletrax.lsg_percentile_bench')});
				chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_children')});
				chart_mibi_bench.xAxis[0].setCategories(['0-1']);
				chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_children')});
				chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_children')});

				if (selectedGender === 'male') {

					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_children_male')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_children_male')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_children_male')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_children_male')});

				} else if(selectedGender === 'female') {

					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_children_female')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_children_female')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_children_female')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_children_female')});

				}

			} else if (selectedAge === 'adults') {

				chart_lufu_bench.xAxis[0].setCategories(['18-29', '30-39', '40-49', '>= 50']);
				chart_lufu_bench.setTitle({text: trans('tripletrax.lufu_adults')});
				chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years_adults')});
				chart_lufu_severity_bench.xAxis[0].setCategories(['18-29', '30-39', '40-49','>= 50']);
				chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1_adults')});
				chart_weight_bench.yAxis[0].setTitle({text: trans('tripletrax.bmi')});
				chart_weight_bench.series[0].update({name: trans('tripletrax.bmi_percentile')});
				chart_weight_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
				chart_weight_bench.xAxis[0].setCategories(['18-29', '30-39', '40-49', '>= 50']);
				chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_adults')});
				chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_adults')});
				chart_weight_years_bench.yAxis[0].setTitle({text: trans('tripletrax.bmi')});
				chart_weight_years_bench.series[0].update({name: trans('tripletrax.bmi_percentile')});
				chart_weight_years_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
				chart_mibi_bench.xAxis[0].setCategories(['18‐29', '30‐39', '40‐49', '>= 50']);
				chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_adults')});
				chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_adults')});

				if(selectedGender === 'male') {

					chart_lufu_bench.setTitle({text: trans('tripletrax.lufu_adults_male')});
					chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years_adults_male')});
					chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1_adults_male')});
					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_adults_male')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_adults_male')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_adults_male')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_adults_male')});

				} else if(selectedGender === 'female') {

					chart_lufu_bench.setTitle({text: trans('tripletrax.lufu_adults_female')});
					chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years_adults_female')});
					chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1_adults_female')});
					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_adults_female')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_adults_female')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_adults_female')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_adults_female')});

				}

			} else {

				if (selectedGender === 'male') {

					chart_lufu_bench.setTitle({text: trans('tripletrax.lufu_male')});
					chart_lufu_bench.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years_male')});
					chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1_male')});
					chart_lufu_severity_bench.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_male')});
					chart_weight_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_male')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_male')});
					chart_mibi_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_male')});

				} else if (selectedGender === 'female') {

					chart_lufu_bench.setTitle({text: trans('tripletrax.lufu_female')});
					chart_lufu_bench.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years_female')});
					chart_lufu_severity_bench.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1_female')});
					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report_female')});
					chart_weight_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years_female')});
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi_female')});
					chart_mibi_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years_female')});

				} else {

					chart_lufu_bench.xAxis[0].setCategories(['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_weight_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']);
					chart_lufu_bench.setTitle({text: trans('tripletrax.lufu')});
					chart_lufu_years_bench.setTitle({text: trans('tripletrax.lufu_years')});
					chart_lufu_severity_bench.xAxis[0].setCategories(['6-11', '12-17', '14-15', '18-29', '20-24', '30-39', '40-49', '>= 50']);
					chart_lufu_severity_bench.setTitle({text: trans('tripletrax.severity_fev1')});
					chart_weight_bench.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
					chart_weight_bench.series[0].update({name: trans('tripletrax.bmi_percentile')});
					chart_weight_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
					chart_weight_bench.setTitle({text: trans('tripletrax.weight_report')});
					chart_weight_years_bench.yAxis[0].setTitle({text: trans('tripletrax.bmi_percentile')});
					chart_weight_years_bench.series[0].update({name: trans('tripletrax.bmi_percentile')});
					chart_weight_years_bench.series[1].update({name: trans('tripletrax.bmi_percentile_bench')});
					chart_weight_years_bench.setTitle({text: trans('tripletrax.weight_years')});
					chart_mibi_bench.xAxis[0].setCategories(['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']);
					chart_mibi_bench.setTitle({text: trans('tripletrax.mibi')});
					chart_mibi_years_bench.setTitle({text: trans('tripletrax.mibi_years')});
				}
			}
			var interval = 0.15;

			var data_lufu = null;
			var data_lufu_patient_numbers = null;
			var data_lufu_bench = null;
			var data_median_lufu_bench = [];
			var data_lufu_patient_numbers_bench = null;
			var data_lufu_years = null;
			var data_median_lufu_years = [];
			var data_lufu_years_patient_numbers = null;
			var data_lufu_years_bench = null;
			var data_median_lufu_years_bench = [];
			var data_lufu_years_patient_numbers_bench = null;
			var data_lufu_severity = null;
			var data_lufu_severity_bench = null;

			if (selectedAge !== 'infants') {
				data_lufu = $('#lufu_facility_bench_graph').data(data_variable);
				var data_median_lufu = [];
				for (var l = 0; l < data_lufu.length; l++) {
					data_median_lufu.push([l - interval, data_lufu[l][2]]);
				}
				data_lufu_patient_numbers = $('#lufu_facility_bench_graph_number_patients').data(data_variable);

				data_lufu_bench = $('#lufu_facility_bench_graph').data(data_bench_variable);
				for (var l = 0; l < data_lufu_bench.length; l++) {
					data_median_lufu_bench.push([l + interval, data_lufu_bench[l][2]]);
				}
				data_lufu_patient_numbers_bench = $('#lufu_facility_bench_graph_number_patients').data(data_bench_variable);

				data_lufu_years = $('#lufu_facility_years_bench_graph').data(data_variable);
				for (var l = 0; l < data_lufu_years.length; l++) {
					data_median_lufu_years.push([data_lufu_years[l][0] - interval, data_lufu_years[l][3]]);
				}
				data_lufu_years_patient_numbers = $('#lufu_facility_years_bench_graph_number_patients').data(data_variable);

				data_lufu_years_bench = $('#lufu_facility_years_bench_graph').data(data_bench_variable);
				for (var l = 0; l < data_lufu_years_bench.length; l++) {
					data_median_lufu_years_bench.push([data_lufu_years_bench[l][0] + interval, data_lufu_years_bench[l][3]]);
				}
				data_lufu_years_patient_numbers_bench = $('#lufu_facility_years_bench_graph_number_patients').data(data_bench_variable);

				data_lufu_severity = $('#lufu_severity_years_bench_graph').data(data_variable);
				data_lufu_severity_bench = $('#lufu_severity_years_bench_graph').data(data_bench_variable);
			}

			var data_weight = $('#weight_facility_bench_graph').data(data_variable);
			var data_median_weight = [];
			for (var l = 0; l < data_weight.length; l++) {
				data_median_weight.push([l - interval, data_weight[l][2]]);
			}
			var data_weight_patient_numbers = $('#weight_facility_bench_graph_number_patients').data(data_variable);

			var data_weight_bench = $('#weight_facility_bench_graph').data(data_bench_variable);
			var data_median_weight_bench = [];
			for (var l = 0; l < data_weight_bench.length; l++) {
				data_median_weight_bench.push([l + interval, data_weight_bench[l][2]]);
			}
			var data_weight_patient_numbers_bench = $('#weight_facility_bench_graph_number_patients').data(data_bench_variable);

			var data_weight_years = $('#weight_facility_years_bench_graph').data(data_variable);
			var data_median_weight_years = [];
			for (var l = 0; l < data_weight_years.length; l++) {
				data_median_weight_years.push([data_weight_years[l][0] - interval, parseFloat(data_weight_years[l][3].toString())]);
			}
			var data_weight_years_patient_numbers = $('#weight_facility_years_bench_graph_number_patients').data(data_variable);

			var data_weight_years_bench = $('#weight_facility_years_bench_graph').data(data_bench_variable);
			var data_median_weight_years_bench = [];
			for (var l = 0; l < data_weight_years_bench.length; l++) {
				data_median_weight_years_bench.push([data_weight_years_bench[l][0] + interval, parseFloat(data_weight_years_bench[l][3].toString())]);
			}
			var data_weight_years_patient_numbers_bench = $('#weight_facility_years_bench_graph_number_patients').data(data_bench_variable);

			var data_mibi = $('#mibi_facility_bench_graph').data(data_variable);
			var data_mibi_bench = $('#mibi_facility_bench_graph').data(data_bench_variable);

			var data_mibi_years = $('#mibi_facility_years_bench_graph').data(data_variable);
			var data_mibi_years_bench = $('#mibi_facility_years_bench_graph').data(data_bench_variable);

			if (selectedAge !== 'infants') {
				$('[name="graphic_type"][value="lufu"]').prop('disabled', false);
				$('[name="graphic_type"][value="lufu"]').parent().removeClass('disabled');
				chart_lufu_bench.series[0].setData($.extend([], data_lufu), false, true, false);
				chart_lufu_bench.series[2].setData($.extend([], data_median_lufu), false, true, false);
				chart_lufu_bench.series[1].setData($.extend([], data_lufu_bench), false, true, false);
				chart_lufu_bench.series[3].setData($.extend([], data_median_lufu_bench), false, true, false);
				chart_lufu_bench.update({
					tooltip: {
						formatter: function () {
							var tooltipString = '<span style="font-size: 10px">' + this.series.xAxis.categories[(this.point.index)] + '</span><br/>';

							if (this.series.options.type === 'spline') {
								tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
							} else {
								var patient_number = 0;

								if (this.series.name === trans('tripletrax.fev1_percent_norm')) {
									for (var key in data_lufu_patient_numbers) {
										if (key === this.point.category) {
											patient_number = data_lufu_patient_numbers[key][0];
										}
									}
								} else {
									for (var key in data_lufu_patient_numbers_bench) {
										if (key === this.point.category) {
											patient_number = data_lufu_patient_numbers_bench[key][0];
										}
									}
								}

								tooltipString += '<span style="color:' +
									this.series.color + '">\u25CF</span> <b> ' +
									this.series.name + '</b><br/>' +
									trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
									trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
									trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
									trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
									trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
									trans('tripletrax.patient_number') + ': ' + patient_number;
							}

							return tooltipString;
						}
					}
				});
				chart_lufu_bench.redraw();

				chart_lufu_years_bench.series[0].setData($.extend([], data_lufu_years), false, true, false);
				chart_lufu_years_bench.series[2].setData($.extend([], data_median_lufu_years), false, true, false);
				chart_lufu_years_bench.series[1].setData($.extend([], data_lufu_years_bench), false, true, false);
				chart_lufu_years_bench.series[3].setData($.extend([], data_median_lufu_years_bench), false, true, false);
				chart_lufu_years_bench.update({

					tooltip: {
						formatter: function () {
							var tooltipString = '';

							if (this.series.options.type === 'spline') {
								if (this.series.name === trans('tripletrax.median')) {
									tooltipString = '<span style="font-size: 10px">' + (this.point.x + interval) + '</span><br/>';
								} else {
									tooltipString = '<span style="font-size: 10px">' + (this.point.x - interval) + '</span><br/>';
								}

								tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
							} else {
								tooltipString = '<span style="font-size: 10px">' + this.point.x + '</span><br/>';
								var patient_number = 0;

								if (this.series.name === trans('tripletrax.fev1_percent_norm')) {
									for (var key in data_lufu_years_patient_numbers) {
										if (key == this.point.category) {
											patient_number = data_lufu_years_patient_numbers[key][0];
										}
									}
								} else {
									for (var key in data_lufu_years_patient_numbers_bench) {
										if (key == this.point.category) {
											patient_number = data_lufu_years_patient_numbers_bench[key][0];
										}
									}
								}

								tooltipString += '<span style="color:' +
									this.series.color + '">\u25CF</span> <b> ' +
									this.series.name + '</b><br/>' +
									trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
									trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
									trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
									trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
									trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
									trans('tripletrax.patient_number') + ': ' + patient_number;
							}

							return tooltipString;
						}
					}

				});
				chart_lufu_years_bench.redraw();

				chart_lufu_severity_bench.series[0].setData($.extend([], data_lufu_severity[2][0]), false, true, false);
				chart_lufu_severity_bench.series[1].setData($.extend([], data_lufu_severity[1][0]), false, true, false);
				chart_lufu_severity_bench.series[2].setData($.extend([], data_lufu_severity[0][0]), false, true, false);
				chart_lufu_severity_bench.series[0].update({composition: $.extend([], data_lufu_severity[2][1])});
				chart_lufu_severity_bench.series[1].update({composition: $.extend([], data_lufu_severity[1][1])});
				chart_lufu_severity_bench.series[2].update({composition: $.extend([], data_lufu_severity[0][1])});
				if (utils.isUndefined(data_lufu_severity_bench) || data_lufu_severity_bench === '') {
					chart_lufu_severity_bench.series[3].setData([], false, true, false);
					chart_lufu_severity_bench.series[4].setData([], false, true, false);
					chart_lufu_severity_bench.series[5].setData([], false, true, false);
					chart_lufu_severity_bench.series[3].update({composition: []});
					chart_lufu_severity_bench.series[4].update({composition: []});
					chart_lufu_severity_bench.series[5].update({composition: []});
				} else {
					chart_lufu_severity_bench.series[3].setData($.extend([], data_lufu_severity_bench[2][0]), false, true, false);
					chart_lufu_severity_bench.series[4].setData($.extend([], data_lufu_severity_bench[1][0]), false, true, false);
					chart_lufu_severity_bench.series[5].setData($.extend([], data_lufu_severity_bench[0][0]), false, true, false);
					chart_lufu_severity_bench.series[3].update({composition: $.extend([], data_lufu_severity_bench[2][1])});
					chart_lufu_severity_bench.series[4].update({composition: $.extend([], data_lufu_severity_bench[1][1])});
					chart_lufu_severity_bench.series[5].update({composition: $.extend([], data_lufu_severity_bench[0][1])});
				}
				chart_lufu_severity_bench.redraw();
			} else {
				$('[name="graphic_type"][value="lufu"]').prop('disabled', 'disabled');
				$('[name="graphic_type"][value="lufu"]').parent().addClass('disabled');
			}

			chart_weight_bench.series[0].setData($.extend([], data_weight), false, true, false);
			chart_weight_bench.series[2].setData($.extend([], data_median_weight), false, true, false);
			chart_weight_bench.series[1].setData($.extend([], data_weight_bench), false, true, false);
			chart_weight_bench.series[3].setData($.extend([], data_median_weight_bench), false, true, false);
			chart_weight_bench.update({

				tooltip: {
					formatter: function () {
						var tooltipString = '<span style="font-size: 10px">' + this.series.xAxis.categories[(this.point.index)] + '</span><br/>';

						if (this.series.options.type === 'spline') {
							tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
						} else {
							var patient_number = 0;

							if (this.series.name === trans('tripletrax.bmi_percentile'))
							{
								for(var key in data_weight_patient_numbers) {
									if (key == this.point.category) {
										patient_number = data_weight_patient_numbers[key][0];
									}
								}
							} else {
								for (var key in data_weight_patient_numbers_bench) {
									if (key == this.point.category) {
										patient_number = data_weight_patient_numbers_bench[key][0];
									}
								}
							}

							tooltipString += '<span style="color:' +
								this.series.color + '">\u25CF</span> <b> ' +
								this.series.name + '</b><br/>' +
								trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
								trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
								trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
								trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
								trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
								trans('tripletrax.patient_number')+ ': ' + patient_number;
						}

						return tooltipString;
					}
				}
			});
			chart_weight_bench.redraw();

			chart_weight_years_bench.series[0].setData($.extend([], data_weight_years), false, true, false);
			chart_weight_years_bench.series[2].setData($.extend([], data_median_weight_years), false, true, false);
			chart_weight_years_bench.series[1].setData($.extend([], data_weight_years_bench), false, true, false);
			chart_weight_years_bench.series[3].setData($.extend([], data_median_weight_years_bench), false, true, false);
			chart_weight_years_bench.update({

				tooltip: {
					formatter: function () {
						var tooltipString = '';

						if (this.series.options.type === 'spline') {
							if (this.series.name === trans('tripletrax.median')) {
								tooltipString = '<span style="font-size: 10px">' + (this.point.x + interval) + '</span><br/>';
							} else {
								tooltipString = '<span style="font-size: 10px">' + (this.point.x - interval) + '</span><br/>';
							}

							tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
						} else {
							tooltipString = '<span style="font-size: 10px">' + this.point.x + '</span><br/>';
							var patient_number = 0;

							if (this.series.name === trans('tripletrax.bmi_percentile'))
							{
								for(var key in data_weight_years_patient_numbers) {
									if (key == this.point.category) {
										patient_number = data_weight_years_patient_numbers[key][0];
									}
								}
							} else {
								for (var key in data_weight_years_patient_numbers_bench) {
									if (key == this.point.category) {
										patient_number = data_weight_years_patient_numbers_bench[key][0];
									}
								}
							}

							tooltipString += '<span style="color:' +
								this.series.color + '">\u25CF</span> <b> ' +
								this.series.name + '</b><br/>' +
								trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
								trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
								trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
								trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
								trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
								trans('tripletrax.patient_number')+ ': ' + patient_number;
						}

						return tooltipString;
					}
				}

			});
			chart_weight_years_bench.redraw();

			chart_mibi_bench.series[0].setData($.extend([], data_mibi[1]), false, true, false);
			chart_mibi_bench.series[1].setData($.extend([], data_mibi[0]), false, true, false);
			chart_mibi_bench.series[2].setData($.extend([], data_mibi_bench[1]), false, true, false);
			chart_mibi_bench.series[3].setData($.extend([], data_mibi_bench[0]), false, true, false);
			chart_mibi_bench.redraw();

			chart_mibi_years_bench.series[0].setData($.extend([], data_mibi_years[1]), false, true, false);
			chart_mibi_years_bench.series[1].setData($.extend([], data_mibi_years[0]), false, true, false);
			chart_mibi_years_bench.series[2].setData($.extend([], data_mibi_years_bench[1]), false, true, false);
			chart_mibi_years_bench.series[3].setData($.extend([], data_mibi_years_bench[0]), false, true, false);
			chart_mibi_years_bench.redraw();

        }

        reflowCharts();
    });

    $('body').on('shown.bs.tab', '.tt-facility-report-tab', function(e) {

        setAdditionalSelection();
        reflowCharts();
    });

	$('body').on('shown.bs.tab', '.tt-patient-reports-tab', function(e) {

		setAdditionalSelection();
		reflowCharts();
	});

	$('body').on('click', '.tt-export-csv', function (e) {
		e.preventDefault();

		$('.' + $(this).data().tableClass).tableExport(
			{
				type:'csv',
				csvSeparator: ';',
				fileName: $(this).data().tableExportName
			}
		);
	});

	$('body').on('click', '.tt-export-excel', function (e) {
		e.preventDefault();

		$('.' + $(this).data().tableClass).tableExport(
			{
				type:'xlsx',
				fileName: $(this).data().tableExportName
			}
		);
	});

	$('body').on('click', '.tt-export-pdf', function (e) {
		e.preventDefault();

		$('.' + $(this).data().tableClass).tableExport(
			{
				type:'pdf',
				jspdf: {
					orientation: 'l',
					autotable: {
						styles: {
							overflow: 'linebreak'
						}
					}
				},
				fileName: $(this).data().tableExportName
			}
		);
	});
}

function setAdditionalSelection() {

    var selectedGraph = $('[name="graphic_type"]:checked').val();
    $('.tt-additional-selection').addClass('hide');

    if ((selectedGraph === 'age_distribution' && $('.tt-facility-report-tab.active').find('[href="#tab_graph1"]').length) || selectedGraph === 'complications' || selectedGraph === 'therapy' || selectedGraph === 'mibi') {
        $('.tt-additional-selection').removeClass('hide');
    }
}

function reflowCharts() {

	$(window).trigger('resize');
    $.each($('.tt-chart,.tt-full-chart,.tt-chart-facility-report,.tt-chart-facility-legend-report'), function(i, chart) {
        $(chart).highcharts().reflow();
    });
}

function setChartPage() {

    if ($('.tt-select-patient-report').length && !utils.isUndefined($('.tt-select-patient-report').select2('val')) && $('.tt-select-patient-report').select2('val') !== '') {

        var selectedReport = $('.tt-select-patient-report').select2('val');
        ajax.ajaxCall(selectedReport + '/' + views.getPatientId() + '/facility/' + views.getFacilityId() + '/model/' + views.getModelId() + '/state/' + views.getPatientIsActive(), 'GET', null, false, function (data) {
            utils.setHtmlData($('#content-detail-reports-detail'), data, true);

            $('#content-detail-reports-detail').find('.tt-patient-name').text(views.setPatientDisplayName());
			$('.tt-content-reports').find('.tt-print-report,.tt-download-report-png').removeClass('hide');

            if (/quick_status$/.test(selectedReport)) {
                addFEV1Graph();
                addHeightWeightBMIGraph();
            } else if (/lufu_chart$/.test(selectedReport)) {
                addLufuGraph();
            } else if (/height_weight_chart$/.test(selectedReport)) {
                addHeightWeightGraph();
            } else if (/bacteria_chart/.test(selectedReport)) {
                addBacteriaGraph();
			} else if (/antibiotic_therapy/.test(selectedReport)) {
				$('.tt-content-reports').find('.tt-print-report,.tt-download-report-png').addClass('hide');
            } else if (/questionnaires/.test(selectedReport)) {
				addQuestionnaireGraph();

			}
            changes.calculateLeftNavHeight();

            $('.tt-print-report,.tt-download-report-png').removeClass('disabled');
            $('.tt-print-report,.tt-download-report-png').removeAttr('disabled');

            reflowCharts();
        });
    } else {
        $('#content-detail-reports-detail').empty();
        $('.tt-print-report,.tt-download-report-png').addClass('disabled');
        $('.tt-print-report,.tt-download-report-png').attr('disabled', 'disabled');
    }
}

function setFacilityChartPage() {

    if ($('.tt-select-report').length && !utils.isUndefined($('.tt-select-report').select2('val')) && $('.tt-select-report').select2('val') !== ''
        && $('.tt-select-frozen-data').length && !utils.isUndefined($('.tt-select-frozen-data').select2('val')) && $('.tt-select-frozen-data').select2('val') !== ''
        && ($('[name="is_admin"]').val() == 0 || ($('[name="is_admin"]').val() == 1 && $('.tt-select-report-facilities').length && !utils.isUndefined($('.tt-select-report-facilities').select2('val')) && $('.tt-select-report-facilities').select2('val') !== ''))) {

        var selectedFacilities = '';
        $('#content-detail').empty();
        if ($('[name="is_admin"]').val() == 1) {
            selectedFacilities = $('.tt-select-report-facilities').select2('val').join('|');
            $('#content-detail').html('<label class="tt-wait-for-report"><i class="fad fa-spinner fa-spin fa-3x fa-fw"></i></label><label class="tt-wait-for-report-label"><span>' + trans('tripletrax.wait_for_report_admin') + '</span></label>');
        } else {
            $('#content-detail').html('<label class="tt-wait-for-report"><i class="fad fa-spinner fa-spin fa-3x fa-fw"></i></label>');
        }
        var selectedReport = $('.tt-select-report').select2('val');
        ajax.ajaxCall(selectedReport + '/frozen_database/' + $('.tt-select-frozen-data').select2('val'), 'GET', 'facilities=' + selectedFacilities, false, function (data) {
            utils.setHtmlData($('#content-detail'), data, true);

			var selectedReport = $('[name="report_type"]:selected').val();
            $('#content-detail').find('.tt-facility-name').text(views.getFacilityDisplayName());

			if (/facility_report$/.test($('.tt-select-report').select2('val'))) {

				addAgeDistributionGraph();
				addPatientCountYearsGraph();
				addAgeDistributionYearsGraph();
				addLufuFacilityGraph();
				addLufuFacilityYearsGraph();
				addLufuFacilitySeverityYearsGraph();
				addWeightFacilityGraph();
				addWeightFacilityYearsGraph();
				addComplicationsFacilityGraph();
				addComplicationsFacilityYearsGraph();
				addTherapyFacilityGraph();
				addTherapyFacilityYearsGraph();
				addMibiFacilityGraph();
				addMibiFacilityYearsGraph();

			} else if (/benchmarking$/.test($('.tt-select-report').select2('val'))) {

				addLufuBenchmarkingGraph();
				addLufuBenchmarkingYearsGraph();
				addLufuBenchmarkingSeverityYearsGraph();
				addWeightBenchmarkingGraph();
				addWeightBenchmarkingYearsGraph();
				addMibiBenchmarkingGraph();
				addMibiBenchmarkingYearsGraph();

				$('.tt-select-report-facility-attributes').val(['ALLE AMBULANZEN']).trigger('change');
			}

            changes.calculateLeftNavHeight();

            $('#report_facility_title').collapse('show');
            $(window).trigger('resize');

            $('.tt-print-report,.tt-download-report-png').removeClass('disabled');
            $('.tt-print-report,.tt-download-report-png').removeAttr('disabled');
        });
    } else {
        $('#content-detail-reports-detail').empty();
        $('.tt-print-report,.tt-download-report-png').addClass('disabled');
        $('.tt-print-report,.tt-download-report-png').attr('disabled', 'disabled');
    }
}

function getBenchData() {

	return $.Deferred(function (defer) {

		utils.updateGlobals('reloadBenchData', false);

		if ($('.tt-select-report').length && !utils.isUndefined($('.tt-select-report').select2('val')) && $('.tt-select-report').select2('val') !== ''
			&& $('.tt-select-frozen-data').length && !utils.isUndefined($('.tt-select-frozen-data').select2('val')) && $('.tt-select-frozen-data').select2('val') !== ''
			&& $('.tt-select-report-facility-attributes').length && !utils.isUndefined($('.tt-select-report-facility-attributes').select2('val')) && $('.tt-select-report-facility-attributes').select2('val') !== '') {

			var selectedReport = $('.tt-select-report').select2('val');
			var data = 'attributes=' + encodeURIComponent($('.tt-select-report-facility-attributes').select2('val').join('|'));
			if ($('.tt-select-report-facilities').length) {
				data += '&facilities=' + encodeURIComponent($('.tt-select-report-facilities').select2('val').join('|'));
			}

			$('.wait-for-bench').removeClass('hide');

			ajax.ajaxCall(selectedReport + '/frozen_database/' + $('.tt-select-frozen-data').select2('val') + '/bench_data', 'GET', data, false, function (data) {

				data = $.parseJSON(data);

				if (data.length === 2) {

					// Lufu
					$('#lufu_facility_bench_graph').data().benchValues = ('fev1' in data[1]) ? data[1]['fev1'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesMale = ('fev1_male' in data[1]) ? data[1]['fev1_male'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesFemale = ('fev1_female' in data[1]) ? data[1]['fev1_female'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesChildren = ('fev1_under_18' in data[1]) ? data[1]['fev1_under_18'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesMaleChildren = ('fev1_male_under_18' in data[1]) ? data[1]['fev1_male_under_18'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesFemaleChildren = ('fev1_female_under_18' in data[1]) ? data[1]['fev1_female_under_18'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesAdults = ('fev1_over_18' in data[1]) ? data[1]['fev1_over_18'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesMaleAdults = ('fev1_male_over_18' in data[1]) ? data[1]['fev1_male_over_18'] : "";
					$('#lufu_facility_bench_graph').data().benchValuesFemaleAdults = ('fev1_female_over_18' in data[1]) ? data[1]['fev1_female_over_18'] : "";

					$('#lufu_facility_bench_graph_number_patients').data().benchValues = ('lufu_table_array' in data[1]) ? data[1]['lufu_table_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesMale = ('lufu_table_male_array' in data[1]) ? data[1]['lufu_table_male_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesFemale = ('lufu_table_female_array' in data[1]) ? data[1]['lufu_table_female_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesChildren = ('lufu_table_array' in data[1]) ? data[1]['lufu_table_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesMaleChildren = ('lufu_table_male_array' in data[1]) ? data[1]['lufu_table_male_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesFemaleChildren = ('lufu_table_female_array' in data[1]) ? data[1]['lufu_table_female_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesAdults = ('lufu_table_array' in data[1]) ? data[1]['lufu_table_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesMaleAdults = ('lufu_table_male_array' in data[1]) ? data[1]['lufu_table_male_array'] : "";
					$('#lufu_facility_bench_graph_number_patients').data().benchValuesFemaleAdults = ('lufu_table_female_array' in data[1]) ? data[1]['lufu_table_female_array'] : "";

					$('#lufu_facility_years_bench_graph').data().benchValues = ('fev1_years' in data[1]) ? data[1]['fev1_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesMale = ('fev1_male_years' in data[1]) ? data[1]['fev1_male_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesFemale = ('fev1_female_years' in data[1]) ? data[1]['fev1_female_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesChildren = ('fev1_under_18_years' in data[1]) ? data[1]['fev1_under_18_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesMaleChildren = ('fev1_male_under_18_years' in data[1]) ? data[1]['fev1_male_under_18_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesFemaleChildren = ('fev1_female_under_18_years' in data[1]) ? data[1]['fev1_female_under_18_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesAdults = ('fev1_over_18_years' in data[1]) ? data[1]['fev1_over_18_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesMaleAdults = ('fev1_male_over_18_years' in data[1]) ? data[1]['fev1_male_over_18_years'] : "";
					$('#lufu_facility_years_bench_graph').data().benchValuesFemaleAdults = ('fev1_female_over_18_years' in data[1]) ? data[1]['fev1_female_over_18_years'] : "";

					$('#lufu_facility_years_bench_graph_number_patients').data().benchValues = ('fev1_years_table_array' in data[1]) ? data[1]['fev1_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesMale = ('fev1_male_years_table_array' in data[1]) ? data[1]['fev1_male_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesFemale = ('fev1_female_years_table_array' in data[1]) ? data[1]['fev1_female_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesChildren = ('fev1_under_18_years_table_array' in data[1]) ? data[1]['fev1_under_18_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesMaleChildren = ('fev1_male_under_18_years_table_array' in data[1]) ? data[1]['fev1_male_under_18_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesFemaleChildren = ('fev1_female_under_18_years_table_array' in data[1]) ? data[1]['fev1_female_under_18_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesAdults = ('fev1_over_18_years_table_array' in data[1]) ? data[1]['fev1_over_18_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesMaleAdults = ('fev1_male_over_18_years_table_array' in data[1]) ? data[1]['fev1_male_over_18_years_table_array'] : "";
					$('#lufu_facility_years_bench_graph_number_patients').data().benchValuesFemaleAdults = ('fev1_female_over_18_years_table_array' in data[1]) ? data[1]['fev1_female_over_18_years_table_array'] : "";

					$('#lufu_severity_years_bench_graph').data().benchValues = ('fev1_severity' in data[1]) ? data[1]['fev1_severity'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesMale = ('fev1_severity_male' in data[1]) ? data[1]['fev1_severity_male'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesFemale = ('fev1_severity_female' in data[1]) ? data[1]['fev1_severity_female'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesChildren = ('fev1_severity_under_18' in data[1]) ? data[1]['fev1_severity_under_18'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesMaleChildren = ('fev1_severity_male_under_18' in data[1]) ? data[1]['fev1_severity_male_under_18'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesFemaleChildren = ('fev1_severity_female_under_18' in data[1]) ? data[1]['fev1_severity_female_under_18'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesAdults = ('fev1_severity_over_18' in data[1]) ? data[1]['fev1_severity_over_18'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesMaleAdults = ('fev1_severity_male_over_18' in data[1]) ? data[1]['fev1_severity_male_over_18'] : "";
					$('#lufu_severity_years_bench_graph').data().benchValuesFemaleAdults = ('fev1_severity_female_over_18' in data[1]) ? data[1]['fev1_severity_female_over_18'] : "";

					addLufuBenchmarkingGraph();
					addLufuBenchmarkingYearsGraph();
					addLufuBenchmarkingSeverityYearsGraph();

					// Körpergewicht
					$('#weight_facility_bench_graph').data().benchValues = ('weight' in data[1]) ? data[1]['weight'] : "";
					$('#weight_facility_bench_graph').data().benchValuesMale = ('weight_male' in data[1]) ? data[1]['weight_male'] : "";
					$('#weight_facility_bench_graph').data().benchValuesFemale = ('weight_female' in data[1]) ? data[1]['weight_female'] : "";
					$('#weight_facility_bench_graph').data().benchValuesChildren = ('weight_under_18' in data[1]) ? data[1]['weight_under_18'] : "";
					$('#weight_facility_bench_graph').data().benchValuesMaleChildren = ('weight_male_under_18' in data[1]) ? data[1]['weight_male_under_18'] : "";
					$('#weight_facility_bench_graph').data().benchValuesFemaleChildren = ('weight_female_under_18' in data[1]) ? data[1]['weight_female_under_18'] : "";
					$('#weight_facility_bench_graph').data().benchValuesInfants = ('weight_under_2' in data[1]) ? data[1]['weight_under_2'] : "";
					$('#weight_facility_bench_graph').data().benchValuesMaleInfants = ('weight_male_under_2' in data[1]) ? data[1]['weight_male_under_2'] : "";
					$('#weight_facility_bench_graph').data().benchValuesFemaleInfants = ('weight_female_under_2' in data[1]) ? data[1]['weight_female_under_2'] : "";
					$('#weight_facility_bench_graph').data().benchValuesAdults = ('weight_over_18' in data[1]) ? data[1]['weight_over_18'] : "";
					$('#weight_facility_bench_graph').data().benchValuesMaleAdults = ('weight_male_over_18' in data[1]) ? data[1]['weight_male_over_18'] : "";
					$('#weight_facility_bench_graph').data().benchValuesFemaleAdults = ('weight_female_over_18' in data[1]) ? data[1]['weight_female_over_18'] : "";

					$('#weight_facility_bench_graph_number_patients').data().benchValues = ('weight_table_array' in data[1]) ? data[1]['weight_table_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesMale = ('weight_table_male_array' in data[1]) ? data[1]['weight_table_male_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesFemale = ('weight_table_female_array' in data[1]) ? data[1]['weight_table_female_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesChildren = ('weight_table_array' in data[1]) ? data[1]['weight_table_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesMaleChildren = ('weight_table_male_array' in data[1]) ? data[1]['weight_table_male_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesFemaleChildren = ('weight_table_female_array' in data[1]) ? data[1]['weight_table_female_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesAdults = ('weight_table_over_18_array' in data[1]) ? data[1]['weight_table_over_18_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesMaleAdults = ('weight_table_male_over_18_array' in data[1]) ? data[1]['weight_table_male_over_18_array'] : "";
					$('#weight_facility_bench_graph_number_patients').data().benchValuesFemaleAdults = ('weight_table_female_over_18_array' in data[1]) ? data[1]['weight_table_female_over_18_array'] : "";

					$('#weight_facility_years_bench_graph').data().benchValues = ('weight_years' in data[1]) ? data[1]['weight_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesMale = ('weight_male_years' in data[1]) ? data[1]['weight_male_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesFemale = ('weight_female_years' in data[1]) ? data[1]['weight_female_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesChildren = ('weight_under_18_years' in data[1]) ? data[1]['weight_under_18_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesMaleChildren = ('weight_male_under_18_years' in data[1]) ? data[1]['weight_male_under_18_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesFemaleChildren = ('weight_female_under_18_years' in data[1]) ? data[1]['weight_female_under_18_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesInfants = ('weight_under_2_years' in data[1]) ? data[1]['weight_under_2_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesMaleInfants = ('weight_male_under_2_years' in data[1]) ? data[1]['weight_male_under_2_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesFemaleInfants = ('weight_female_under_2_years' in data[1]) ? data[1]['weight_female_under_2_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesAdults = ('weight_over_18_years' in data[1]) ? data[1]['weight_over_18_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesMaleAdults = ('weight_male_over_18_years' in data[1]) ? data[1]['weight_male_over_18_years'] : "";
					$('#weight_facility_years_bench_graph').data().benchValuesFemaleAdults = ('weight_female_over_18_years' in data[1]) ? data[1]['weight_female_over_18_years'] : "";

					$('#weight_facility_years_bench_graph_number_patients').data().benchValues = ('weight_years_table_array' in data[1]) ? data[1]['weight_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesMale = ('weight_male_years_table_array' in data[1]) ? data[1]['weight_male_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesFemale = ('weight_female_years_table_array' in data[1]) ? data[1]['weight_female_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesChildren = ('weight_under_18_years_table_array' in data[1]) ? data[1]['weight_under_18_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesMaleChildren = ('weight_male_under_18_years_table_array' in data[1]) ? data[1]['weight_male_under_18_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesFemaleChildren = ('weight_female_under_18_years_table_array' in data[1]) ? data[1]['weight_female_under_18_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesInfants = ('weight_under_2_years_table_array' in data[1]) ? data[1]['weight_under_2_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesMaleInfants = ('weight_male_under_2_years_table_array' in data[1]) ? data[1]['weight_male_under_2_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesFemaleInfants = ('weight_female_under_2_years_table_array' in data[1]) ? data[1]['weight_female_under_2_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesAdults = ('weight_over_18_years_table_array' in data[1]) ? data[1]['weight_over_18_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesMaleAdults = ('weight_male_over_18_years_table_array' in data[1]) ? data[1]['weight_male_over_18_years_table_array'] : "";
					$('#weight_facility_years_bench_graph_number_patients').data().benchValuesFemaleAdults = ('weight_female_over_18_years_table_array' in data[1]) ? data[1]['weight_female_over_18_years_table_array'] : "";

					addWeightBenchmarkingGraph();
					addWeightBenchmarkingYearsGraph();

					// MiBi
					$('#mibi_facility_bench_graph').data().benchValues = ('mibi_percent' in data[1]) ? data[1]['mibi_percent'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesMale = ('mibi_percent_male' in data[1]) ? data[1]['mibi_percent_male'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesFemale = ('mibi_percent_female' in data[1]) ? data[1]['mibi_percent_female'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesChildren = ('mibi_percent_under_18' in data[1]) ? data[1]['mibi_percent_under_18'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesMaleChildren = ('mibi_percent_male_under_18' in data[1]) ? data[1]['mibi_percent_male_under_18'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesFemaleChildren = ('mibi_percent_female_under_18' in data[1]) ? data[1]['mibi_percent_female_under_18'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesInfants = ('mibi_percent_under_2' in data[1]) ? data[1]['mibi_percent_under_2'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesMaleInfants = ('mibi_percent_male_under_2' in data[1]) ? data[1]['mibi_percent_male_under_2'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesFemaleInfants = ('mibi_percent_female_under_2' in data[1]) ? data[1]['mibi_percent_female_under_2'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesAdults = ('mibi_percent_over_18' in data[1]) ? data[1]['mibi_percent_over_18'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesMaleAdults = ('mibi_percent_male_over_18' in data[1]) ? data[1]['mibi_percent_male_over_18'] : "";
					$('#mibi_facility_bench_graph').data().benchValuesFemaleAdults = ('mibi_percent_female_over_18' in data[1]) ? data[1]['mibi_percent_female_over_18'] : "";

					$('#mibi_facility_years_bench_graph').data().benchValues = ('mibi_percent_years' in data[1]) ? data[1]['mibi_percent_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesMale = ('mibi_percent_male_years' in data[1]) ? data[1]['mibi_percent_male_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesFemale = ('mibi_percent_female_years' in data[1]) ? data[1]['mibi_percent_female_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesChildren = ('mibi_percent_under_18_years' in data[1]) ? data[1]['mibi_percent_under_18_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesMaleChildren = ('mibi_percent_male_under_18_years' in data[1]) ? data[1]['mibi_percent_male_under_18_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesFemaleChildren = ('mibi_percent_female_under_18_years' in data[1]) ? data[1]['mibi_percent_female_under_18_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesInfants = ('mibi_percent_under_2_years' in data[1]) ? data[1]['mibi_percent_under_2_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesMaleInfants = ('mibi_percent_male_under_2_years' in data[1]) ? data[1]['mibi_percent_male_under_2_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesFemaleInfants = ('mibi_percent_female_under_2_years' in data[1]) ? data[1]['mibi_percent_female_under_2_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesAdults = ('mibi_percent_over_18_years' in data[1]) ? data[1]['mibi_percent_over_18_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesMaleAdults = ('mibi_percent_male_over_18_years' in data[1]) ? data[1]['mibi_percent_male_over_18_years'] : "";
					$('#mibi_facility_years_bench_graph').data().benchValuesFemaleAdults = ('mibi_percent_female_over_18_years' in data[1]) ? data[1]['mibi_percent_female_over_18_years'] : "";

					addMibiBenchmarkingGraph();
					addMibiBenchmarkingYearsGraph();

				}

				$('.wait-for-bench').addClass('hide');

				if (utils.GLOBALS.reloadBenchData) {
					utils.GLOBALS.reloadBenchData = false;
					defer.resolve();
					getBenchData();
				} else {
					defer.resolve();
				}
			});

		} else {
			defer.resolve();
		}
	});
}

function addFEV1Graph() {

    var data = getSeriesData($('#fev1_graph').data().values);

    $('#fev1_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.fev1_trend'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            type: 'datetime',
            tickWidth: 0,
            gridLineWidth: 1,
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            }
        },

        yAxis: {
            title: {
                text: '%'
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        },

        legend: {
            align: 'left',
            verticalAlign: 'top',
            y: 20,
            floating: true,
            borderWidth: 0
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            formatter: function () {
                var s = '<b>' + utils.dateToLocaleString(this.x) + '</b>';

                $.each(this.points, function () {
                    s += '<br/>' + this.series.name + ': <b>' + utils.numberToString(this.y) + '</b>';
                });

                return s;
            }
        },

        series: [{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            data: data[0],
            name: trans('tripletrax.fev1_percent_norm')
        }],

        plotOptions: {
            series: {
                color: '#3276b1'
            }
        }
    });

    addButtonsToChart($('#fev1_graph'));

    var chart = $('#fev1_graph').highcharts();
    if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
        chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
    }
}

function addHeightWeightBMIGraph() {

    var data = getSeriesData($('#height_weight_bmi_graph').data().values);

    var title = '';
    var series = [];
    var yAxis = [];
	if ($('#height_weight_bmi_graph').data().age < 2) {

		series = [{
			lineWidth: 2,
			marker: {
				enabled: true,
				radius: 4
			},
			name: trans('tripletrax.height'),
			data: data[0],
			color: '#96bf48'
		}, {
			lineWidth: 2,
			marker: {
				enabled: true,
				radius: 4
			},
			name: trans('tripletrax.weight'),
			data: data[1],
			color: '#E2B14A'
		}, {
			lineWidth: 2,
			marker: {
				enabled: true,
				radius: 4
			},
			yAxis: 1,
			name: trans('tripletrax.lsg'),
			data: data[2],
			color: '#d9534f'
		}];

		yAxis = [{
			title: {
				text: trans('tripletrax.percentile')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true
		}, {
			opposite: true,
			title: {
				text: '%'
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true
		}];

		title = trans('tripletrax.height_weight_lsg_trend');

	} else if ($('#height_weight_bmi_graph').data().age < 18) {

        series = [{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: trans('tripletrax.height'),
            data: data[0],
            color: '#96bf48'
        },{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: trans('tripletrax.weight'),
            data: data[1],
            color: '#E2B14A'
        },{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: trans('tripletrax.bmi'),
            data: data[2],
            color: '#d9534f'
        }];

        yAxis = [{
            title: {
                text: trans('tripletrax.percentile')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        }];

        title = trans('tripletrax.height_weight_bmi_trend');

    } else {

        series = [{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            yAxis: 0,
            name: trans('tripletrax.weight'),
            data: data[0],
            color: '#96bf48'
        },{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            yAxis: 1,
            name: trans('tripletrax.bmi'),
            data: data[1],
            color: '#E2B14A'
        }];

        yAxis = [{
            title: {
                text: 'kg'
            },
            labels: {
                format: '{value:.0f}'
            },
            showFirstLabel: true
        }, {
            title: {
                text: 'kg/m²'
            },
            labels: {
                format: '{value:.0f}'
            },
            showFirstLabel: true,
            opposite: true
        }];

        title = trans('tripletrax.weight_bmi_trend');
    }

    $('#height_weight_bmi_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: title,
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            type: 'datetime',
            tickWidth: 0,
            gridLineWidth: 1,
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            }
        },

        yAxis: yAxis,

        legend: {
            align: 'left',
            verticalAlign: 'top',
            y: 20,
            floating: true,
            borderWidth: 0
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            formatter: function () {
                var s = '<b>' + utils.dateToLocaleTimeString(this.x, false) + '</b>';

                $.each(this.points, function () {
                    s += '<br/>' + this.series.name + ': <b>' + utils.numberToString(this.y) + '</b>';
                });

                return s;
            }
        },

        series: series

    });

    addButtonsToChart($('#height_weight_bmi_graph'));

    var chart = $('#height_weight_bmi_graph').highcharts();
    if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
        chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
    }
}

function addLufuGraph() {

    var data = [];
    var yAxis = [];
    var plotLines = [];
    var fev1Name = '';
    var fvcName = '';
    var mef25Name = '';
    var mef75Name = '';
    var yAxisCounter = 0;
    if ($('[name="lufu_value_type"][value="norm"]').prop('checked')) {
        data = getSeriesData($('#lufu_graph').data().valuesLufuNorm);
        fev1Name = trans('tripletrax.fev1_percent_norm');
        fvcName = trans('tripletrax.fvc_percent_norm');
        mef25Name = trans('tripletrax.mef25_percent_norm');
        mef75Name = trans('tripletrax.mef75_percent_norm');

        yAxis.push({
            title: {
                text: '%'
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        });
    } else {
        data = getSeriesData($('#lufu_graph').data().valuesLufuAbsolute);
        fev1Name = trans('tripletrax.fev1');
        fvcName = trans('tripletrax.fvc');
        mef25Name = trans('tripletrax.mef25');
        mef75Name = trans('tripletrax.mef75');

        yAxis.push({
            title: {
                text: $('#lufu_graph').data().defaultUnitFev1Fvc
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        },{
            title: {
                text: $('#lufu_graph').data().defaultUnitMef25Mef75
            },
            labels: {
                format: '{value:.,0f}'
            },
            opposite: true,
            showFirstLabel: true
        });

        yAxisCounter = 1;
    }

    var dataChronicPseudomonas = getXRangeSeriesData($('#lufu_graph').data().valuesChronicPseudomonas);
    var dataPseudomonas = getXRangeSeriesData($('#lufu_graph').data().valuesPseudomonas);
    var dataABPA = getXRangeSeriesData($('#lufu_graph').data().valuesAbpa);
    var dataAntibioticTherapy = getXRangeSeriesData($('#lufu_graph').data().valuesAntibioticTherapy);
    var dataHospitalization = getXRangeSeriesData($('#lufu_graph').data().valuesHospitalization);
    var dataAntimycotica = getXRangeSeriesData($('#lufu_graph').data().valuesAntimycotica);
    var dataOralSteroids = getXRangeSeriesData($('#lufu_graph').data().valuesOralSteroids);
    var dataCftr = getXRangeSeriesData($('#lufu_graph').data().valuesCftr);
    var dataOralDiabeticTherapy = getXRangeSeriesData($('#lufu_graph').data().valuesOralDiabeticTherapy);
    var dataInsulinTherapy = getXRangeSeriesData($('#lufu_graph').data().valuesInsulinTherapy);
    var dataMannitol = getXRangeSeriesData($('#lufu_graph').data().valuesMannitol);
    var dataHypertonicSaltSolution = getXRangeSeriesData($('#lufu_graph').data().valuesHypertonicSaltSolution);
    var dataDnase = getXRangeSeriesData($('#lufu_graph').data().valuesDnase);
    var dataAntiStaphylococcusTherapy = getXRangeSeriesData($('#lufu_graph').data().valuesAntiStaphylococcusTherapy);
    var dataAzithromycin = getXRangeSeriesData($('#lufu_graph').data().valuesAzithromycin);
    var dataInhalativLongTermAntibiosis = getXRangeSeriesData($('#lufu_graph').data().valuesInhalativLongTermAntibiosis);
    var dataTransplantation = $('#lufu_graph').data().valuesTransplantation.split('|');

    for (var i = 0; i < dataTransplantation.length; i++) {
        if (dataTransplantation[i] !== '') {
            var dateArray = dataTransplantation[i].split('#');
            var dateString = '';
            if (dateArray[1] === '') {
                dateString = utils.dateToLocaleString(dateArray[0]);
            } else {
                dateString = utils.dateToLocaleFormatString(dateArray[0], utils.getMomentFormat(dateArray[1]));
            }

            plotLines.push({
                color: '#92A2A8',
                width: 2,
                value: utils.stringToUTCDate(dateArray[0]),
                label: {
                    style: {
                        color: '#92A2A8'
                    },
                    text: trans('tripletrax.transplantation_lung') + ': ' + dateString,
                    verticalAlign: 'bottom',
                    textAlign: 'right',
                    y: -5
                },
                zIndex: 5
            });
        }
    }

    var top = 210;
    var steps = 27;
    var barHeight = 11;

    yAxis.push({
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 16,
        max: 16,
        top: top + steps * 0

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 15,
        max: 15,
        top: top + steps * 1

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 14,
        max: 14,
        top: top + steps * 2

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 13,
        max: 13,
        top: top + steps * 3

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 12,
        max: 12,
        top: top + steps * 4

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 11,
        max: 11,
        top: top + steps * 5

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 10,
        max: 10,
        top: top + steps * 6

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 9,
        max: 9,
        top: top + steps * 7

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 8,
        max: 8,
        top: top + steps * 8

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 7,
        max: 7,
        top: top + steps * 9

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 6,
        max: 6,
        top: top + steps * 10

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 5,
        max: 5,
        top: top + steps * 11

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 4,
        max: 4,
        top: top + steps * 12

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 3,
        max: 3,
        top: top + steps * 13

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 2,
        max: 2,
        top: top + steps * 14

    }, {
        gridLineWidth: 0,
        title: '',
        labels: {
            enabled: false
        },
        opposite: false,
        min: 1,
        max: 1,
        top: top + steps * 15

    });

    $('#lufu_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'xrange',
            zoomType: 'x',
            marginLeft: 250,
            marginTop: 40,
            height: 750,
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
            //events: {
            //      redraw: function () {
            //          jQuery.each($('#lufu_graph').find('.highcharts-legend-item'), function (i, element) {
            //              if (i > 1 && !$(element).hasClass('tt-redraw')) {
            //                  var transform = $(element).attr('transform').split(',');
            //                  var yValue = parseInt(transform[1].replace(')', '')) + 210;
            //
            //                  $(element).attr('transform', transform[0] + ',' + yValue.toString() + ')');
            //                  $(element).addClass('tt-redraw');
            //              }
            //          });
            //      }
            //}
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: '',
            style: {
                fontSize: '16px'
            }
        },

        xAxis: [{
            offset: 0,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            },
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1,
            plotLines: plotLines
        },{
            offset: 450,
            linkedTo: 1,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            },
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1
        }],

        yAxis: yAxis,

        legend: {
            layout: 'vertical',
            itemMarginBottom: 4,
            align: 'left',
            x: 0,
            verticalAlign: 'top',
            y: 35,
            floating: true,
            borderWidth: 0,
            labelFormatter: function() {
                var words = this.name.split(/[\s]+/);
                var numWordsPerLine = 3;
                var str = [];
                $('#content').append('<span id="content_string_width"></span>');

                var tempString = [];
                for (var word in words) {
                    tempString.push(words[word]);
                    $('#content_string_width').text(tempString.join(' '));
                    if ($('#content_string_width').width() > 150) {
                        str.push('<br>');
                        tempString = [];
                        tempString.push(words[word]);
                    }


                    str.push(words[word]);
                }
                $('#content_string_width').remove();

                return str.join(' ');
            }
        },

        tooltip: {
            shared: false,
            //crosshairs: true,
            formatter: function () {
                if (!utils.isUndefined(this.point.x2)) {
                    var s = '<b>' + utils.dateToLocaleString(this.x) + ' - ' + utils.dateToLocaleString(this.point.x2) + '</b>';
                    s += '<br/>' + this.series.name;

                    return s;
                } else {
                    var s = '<b>' + utils.dateToLocaleString(this.x) + '</b>';
                    s += '<br/>' + this.series.name + ': <b>' + utils.numberToString(this.y) + '</b>';

                    return s;
                }
            }
        },

        series: [{
            yAxis: 0,
            xAxis: 0,
            type: 'line',
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: fev1Name,
            data: data[0],
            color: '#3276b1'
        },{
            yAxis: 0,
            xAxis: 0,
            type: 'line',
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: fvcName,
            data: data[1],
            color: '#96bf48'
        },{
            yAxis: yAxisCounter,
            xAxis: 0,
            type: 'line',
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: mef25Name,
            data: data[2],
            color: '#E2B14A'
        },{
            yAxis: yAxisCounter,
            xAxis: 0,
            type: 'line',
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            name: mef75Name,
            data: data[3],
            color: '#d9534f'
        },{
            yAxis: yAxisCounter + 1,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.inhalativ_long_term_antibiosis'),
            data: dataInhalativLongTermAntibiosis,
            color: '#496949'
        },{
            yAxis: yAxisCounter + 2,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.azithromycin'),
            data: dataAzithromycin,
            color: '#3276b1'
        },{
            yAxis: yAxisCounter + 3,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.anti_staphylococcus_therapy'),
            data: dataAntiStaphylococcusTherapy,
            color: '#4C4F53'
        },{
            yAxis: yAxisCounter + 4,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.dnase'),
            data: dataDnase,
            color: '#A8829F'
        },{
            yAxis: yAxisCounter + 5,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.hypertonic_salt_solution'),
            data: dataHypertonicSaltSolution,
            color: '#AC5287'
        },{
            yAxis: yAxisCounter + 6,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.mannitol'),
            data: dataMannitol,
            color: '#356E35'
        },{
            yAxis: yAxisCounter + 7,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.oral_diabetic_therapy'),
            data: dataOralDiabeticTherapy,
            color: '#92A2A8'
        },{
            yAxis: yAxisCounter + 8,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.insulin_therapy'),
            data: dataInsulinTherapy,
            color: '#57889C'
        },{
            yAxis: yAxisCounter + 9,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.cftr'),
            data: dataCftr,
            color: '#A65858'
        },{
            yAxis: yAxisCounter + 10,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.oral_steroids'),
            data: dataOralSteroids,
            color: '#DB4A67'
        },{
            yAxis: yAxisCounter + 11,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.antimycotica'),
            data: dataAntimycotica,
            color: '#D6A848'
        },{
            yAxis: yAxisCounter + 12,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.hospitalization'),
            data: dataHospitalization,
            color: '#6e3671'
        },{
            yAxis: yAxisCounter + 13,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.antibiotic_therapy'),
            data: dataAntibioticTherapy,
            color: '#568a89'
        },{
            yAxis: yAxisCounter + 14,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.abpa'),
            data: dataABPA,
            color: '#f7a35c'
        },{
            yAxis: yAxisCounter + 15,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.pseudomonas'),
            data: dataPseudomonas,
            color: '#3b9ff3'
        },{
            yAxis: yAxisCounter + 16,
            xAxis: 0,
            borderRadius: 0,
            height: barHeight,
            name: trans('tripletrax.pseudomonas_chronic'),
            data: dataChronicPseudomonas,
            color: '#B1811D'
        }],

        plotOptions: {
            series: {
                color: '#3276b1',
                pointRange: 24 * 3600 * 1000 // one day
            }
        }
    });

    addButtonsToChart($('#lufu_graph'));

    var chart = $('#lufu_graph').highcharts();
    if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
        chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
    }
}

function addHeightWeightGraph() {

    var data = [];
    var plotLines = [];
    var percentileData = null;
    var titleText = '';
    var percentileSeriesNames = [];
    var seriesName = '';
    if ($('[name="height_weight_value_type"][value="height"]').prop('checked')) {
        data = getSeriesData($('#height_weight_graph').data().valuesHeight);
        percentileData = getSeriesData($('#height_weight_graph').data().percentilesHeight);
        seriesName = trans('tripletrax.height');
        titleText = $('#height_weight_graph').data().defaultUnitHeight;
        if (percentileData.length) {
            percentileSeriesNames = ($('#height_weight_graph').data().percentilesHeight.split('|'))[0].split(',');
        }
    } else if ($('[name="height_weight_value_type"][value="weight"]').prop('checked')) {
        data = getSeriesData($('#height_weight_graph').data().valuesWeight);
        percentileData = getSeriesData($('#height_weight_graph').data().percentilesWeight);
        seriesName = trans('tripletrax.weight');
        titleText = $('#height_weight_graph').data().defaultUnitWeight;
        if (percentileData.length) {
            percentileSeriesNames = ($('#height_weight_graph').data().percentilesWeight.split('|'))[0].split(',');
        }
    } else {
        data = getSeriesData($('#height_weight_graph').data().valuesBmi);
        percentileData = getSeriesData($('#height_weight_graph').data().percentilesBmi);
        seriesName = trans('tripletrax.bmi');
        titleText = $('#height_weight_graph').data().defaultUnitBmi;
        if (percentileData.length) {
            percentileSeriesNames = ($('#height_weight_graph').data().percentilesBmi.split('|'))[0].split(',');
        }
    }

    var dataProtonInhibitors = getXRangeSeriesData($('#height_weight_graph').data().valuesProtonInhibitors);
    var dataAdditionalAlimentationOral = getXRangeSeriesData($('#height_weight_graph').data().valuesAdditionalAlimentationOral);
    var dataAdditionalAlimentationTube = getXRangeSeriesData($('#height_weight_graph').data().valuesAdditionalAlimentationTube);
    var dataCftr = getXRangeSeriesData($('#height_weight_graph').data().valuesCftr);
    var dataOralDiabeticTherapy = getXRangeSeriesData($('#height_weight_graph').data().valuesOralDiabeticTherapy);
    var dataInsulinTherapy = getXRangeSeriesData($('#height_weight_graph').data().valuesInsulinTherapy);
    var dataAntibioticTherapy = getXRangeSeriesData($('#height_weight_graph').data().valuesAntibioticTherapy);
    var dataHospitalization = getXRangeSeriesData($('#height_weight_graph').data().valuesHospitalization);
    var dataTransplantation = $('#height_weight_graph').data().valuesTransplantation.split('|');

    for (var i = 0; i < dataTransplantation.length; i++) {
        if (dataTransplantation[i] !== '') {
            var dateArray = dataTransplantation[i].split('#');
            var dateString = '';
            if (dateArray[1] === '') {
                dateString = utils.dateToLocaleString(dateArray[0]);
            } else {
                dateString = utils.dateToLocaleFormatString(dateArray[0], utils.getMomentFormat(dateArray[1]));
            }

            plotLines.push({
                color: '#92A2A8',
                width: 2,
                value: utils.stringToUTCDate(dateArray[0]),
                label: {
                    style: {
                        color: '#92A2A8'
                    },
                    text: trans('tripletrax.transplantation_liver') + ': ' + dateString,
                    verticalAlign: 'bottom',
                    textAlign: 'right',
                    y: -5
                },
                zIndex: 5
            });
        }
    }

    var top = 300;
    var steps = 30;

    var yAxis = [{
            title: {
                text: titleText
            },
            labels: {
                format: '{value:.0f}'
            },
            showFirstLabel: true
        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 8,
            max: 8,
            top: top + steps * 0

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 7,
            max: 7,
            top: top + steps * 1

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 6,
            max: 6,
            top: top + steps * 2

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 5,
            max: 5,
            top: top + steps * 3

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 4,
            max: 4,
            top: top + steps * 4

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 3,
            max: 3,
            top: top + steps * 5

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 2,
            max: 2,
            top: top + steps * 6

        }, {
            gridLineWidth: 0,
            title: '',
            labels: {
                enabled: false
            },
            opposite: false,
            min: 1,
            max: 1,
            top: top + steps * 7

        }];

    var series = [{
        yAxis: 0,
        xAxis: 0,
        type: 'line',
        lineWidth: 2,
        marker: {
            enabled: true,
            radius: 4
        },
        name: seriesName,
        data: data[0],
        color: '#3276B1'
    }, {
        yAxis: 1,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.proton_inhibitors'),
        data: dataProtonInhibitors,
        color: '#DB4A67'
    }, {
        yAxis: 2,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.additional_alimentation_oral'),
        data: dataAdditionalAlimentationOral,
        color: '#92A2A8'
    }, {
        yAxis: 3,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.additional_alimentation_tube'),
        data: dataAdditionalAlimentationTube,
        color: '#57889C'
    }, {
        yAxis: 4,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.oral_diabetic_therapy'),
        data: dataOralDiabeticTherapy,
        color: '#6e3671'
    }, {
        yAxis: 5,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.insulin_therapy'),
        data: dataInsulinTherapy,
        color: '#D6A848'
    }, {
        yAxis: 6,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.cftr'),
        data: dataCftr,
        color: '#568a89'
    }, {
        yAxis: 7,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.hospitalization'),
        data: dataHospitalization,
        color: '#f7a35c'
    }, {
        yAxis: 8,
        xAxis: 0,
        borderRadius: 0,
        height: 11,
        name: trans('tripletrax.antibiotic_therapy'),
        data: dataAntibioticTherapy,
        color: '#3b9ff3'
    }];

    if (!utils.isUndefined(percentileData) && percentileData.length) {

        var colors = [];
        if (percentileData.length === 7) {
            colors = ['#f7a35c', '#D6A848', '#96bf48', '#356E35', '#96bf48', '#D6A848', '#f7a35c'];
        } else {
            colors = ['#DB4A67', '#f7a35c', '#D6A848', '#EDDF48', '#96bf48', '#356E35', '#96bf48', '#EDDF48', '#D6A848', '#f7a35c', '#DB4A67'];
        }
        var arrayLength = percentileData.length;
        for (var i = 0; i < arrayLength; i++) {

            series.push({
                showInLegend: false,
                yAxis: 0,
                lineWidth: 1,
                type: 'line',
                name: percentileSeriesNames[i + 1],
                marker: {
                    enabled: true,
                    radius: 0
                },
                data: percentileData[i],
                color: colors[i]
            })
        }
    }

    $('#height_weight_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'xrange',
            zoomType: 'x',
            marginLeft: 250,
            height: 750,
            marginTop: 40,
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: '',
            style: {
                fontSize: '16px'
            }
        },

        xAxis: [{
            offset: 0,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            },
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1,
            plotLines: plotLines
        },{
            offset: 250,
            linkedTo: 1,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            },
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1
        }],

        yAxis: yAxis,

        legend: {
            layout: 'vertical',
            itemMarginBottom: 4,
            align: 'left',
            x: 0,
            verticalAlign: 'top',
            y: 35,
            floating: true,
            borderWidth: 0,
            labelFormatter: function () {
                var words = this.name.split(/[\s]+/);
                var numWordsPerLine = 3;
                var str = [];
                $('#content').append('<span id="content_string_width"></span>');

                var tempString = [];
                for (var word in words) {
                    tempString.push(words[word]);
                    $('#content_string_width').text(tempString.join(' '));
                    if ($('#content_string_width').width() > 150) {
                        str.push('<br>');
                        tempString = [];
                        tempString.push(words[word]);
                    }


                    str.push(words[word]);
                }
                $('#content_string_width').remove();

                return str.join(' ');
            }
        },

        tooltip: {
            shared: false,
            //crosshairs: true,
            formatter: function () {
                if (!utils.isUndefined(this.point.x2)) {
                    var s = '<b>' + utils.dateToLocaleString(this.x) + ' - ' + utils.dateToLocaleString(this.point.x2) + '</b>';
                    s += '<br/>' + this.series.name;

                    return s;
                } else {
                    var s = '<b>' + utils.dateToLocaleString(this.x) + '</b>';
                    s += '<br/>' + this.series.name + ': <b>' + utils.numberToString(this.y) + '</b>';

                    return s;
                }
            }
        },

        series: series,

        plotOptions: {
            series: {
                color: '#3276b1',
                pointRange: 24 * 3600 * 1000 // one day
            }
        }

    });

    addButtonsToChart($('#height_weight_graph'));

    var chart = $('#height_weight_graph').highcharts();
    if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
        chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
    }
}

function addBacteriaGraph() {

    var dataPseudomonas = getSeriesData($('#bacteria_graph').data().valuesPseudomonas)[0];
    var dataPseudomonasNegative = getSeriesData($('#bacteria_graph').data().valuesPseudomonasNegative)[0];
    var dataPseudomonasMucoid = getSeriesData($('#bacteria_graph').data().valuesPseudomonasMucoid)[0];
    var dataPseudomonasMdr = getSeriesData($('#bacteria_graph').data().valuesPseudomonasMdr)[0];
    var dataStaph = getSeriesData($('#bacteria_graph').data().valuesStaph)[0];
    var dataStaphNegative = getSeriesData($('#bacteria_graph').data().valuesStaphNegative)[0];
    var dataMrsa = getSeriesData($('#bacteria_graph').data().valuesMrsa)[0];
    var dataMrsaNegative = getSeriesData($('#bacteria_graph').data().valuesMrsaNegative)[0];
    var dataBurkholderia = getSeriesData($('#bacteria_graph').data().valuesBurkholderia)[0];
    var dataBurkholderiaNegative = getSeriesData($('#bacteria_graph').data().valuesBurkholderiaNegative)[0];
    var dataStenotrophomonas = getSeriesData($('#bacteria_graph').data().valuesStenotrophomonas)[0];
    var dataStenotrophomonasNegative = getSeriesData($('#bacteria_graph').data().valuesStenotrophomonasNegative)[0];
    var dataAchromobacter = getSeriesData($('#bacteria_graph').data().valuesAchromobacter)[0];
    var dataAchromobacterNegative = getSeriesData($('#bacteria_graph').data().valuesAchromobacterNegative)[0];
    var dataMycobacteria = getSeriesData($('#bacteria_graph').data().valuesMycobacteria)[0];
    var dataMycobacteriaNegative = getSeriesData($('#bacteria_graph').data().valuesMycobacteriaNegative)[0];

    var series = [{
        name: trans('tripletrax.pseudomonas') + ' (' + trans('tripletrax.positive') + ')',
        data: dataPseudomonas,
        color: '#cbcbcb'
    }, {
        name: trans('tripletrax.pseudomonas') + ' (' + trans('tripletrax.negative') + ')',
        data: dataPseudomonasNegative,
        color: '#cbcbcb',
        marker: {
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#cbcbcb'
        }
    }, {
        name: trans('tripletrax.pseudomonas_mucoid'),
        data: dataPseudomonasMucoid,
        color: '#DB4A67',
        marker: {
            radius: 6,
            symbol: 'circle'
        }
    }, {
        name: trans('tripletrax.pseudomonas_mdr'),
        data: dataPseudomonasMdr,
        color: '#60B616',
        marker: {
            radius: 5,
            symbol: 'diamond'
        }
    }, {
        name: trans('tripletrax.staph') + ' (' + trans('tripletrax.positive') + ')',
        data: dataStaph,
        color: '#6e3671'
    }, {
        name: trans('tripletrax.staph') + ' (' + trans('tripletrax.negative') + ')',
        data: dataStaphNegative,
        color: '#6e3671',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#6e3671'
        }
    }, {
        name: trans('tripletrax.mrsa') + ' (' + trans('tripletrax.positive') + ')',
        data: dataMrsa,
        color: '#D6A848'
    }, {
        name: trans('tripletrax.mrsa') + ' (' + trans('tripletrax.negative') + ')',
        data: dataMrsaNegative,
        color: '#D6A848',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#D6A848'
        }
    }, {
        name: trans('tripletrax.burkholderia') + ' (' + trans('tripletrax.positive') + ')',
        data: dataBurkholderia,
        color: '#568a89'
    }, {
        name: trans('tripletrax.burkholderia') + ' (' + trans('tripletrax.negative') + ')',
        data: dataBurkholderiaNegative,
        color: '#568a89',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#568a89'
        }
    }, {
        name: trans('tripletrax.stenotrophomonas') + ' (' + trans('tripletrax.positive') + ')',
        data: dataStenotrophomonas,
        color: '#f7a35c'
    }, {
        name: trans('tripletrax.stenotrophomonas') + ' (' + trans('tripletrax.negative') + ')',
        data: dataStenotrophomonasNegative,
        color: '#f7a35c',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#f7a35c'
        }
    }, {
        name: trans('tripletrax.achromobacter') + ' (' + trans('tripletrax.positive') + ')',
        data: dataAchromobacter,
        color: '#3b9ff3'
    }, {
        name: trans('tripletrax.achromobacter') + ' (' + trans('tripletrax.negative') + ')',
        data: dataAchromobacterNegative,
        color: '#3b9ff3',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#3b9ff3'
        }
    }, {
        name: trans('tripletrax.mycobacteria') + ' (' + trans('tripletrax.confirmed') + ')',
        data: dataMycobacteria,
        color: '#AA4643'
    }, {
        name: trans('tripletrax.mycobacteria') + ' (' + trans('tripletrax.unconfirmed') + ')',
        data: dataMycobacteriaNegative,
        color: '#AA4643',
        marker: {
            radius: 7,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: '#AA4643'
        }
    }];

    $('#bacteria_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'scatter',
            zoomType: 'xy',
            marginLeft: 250,
            height: 740,
            marginTop: 40,
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: '',
            style: {
                fontSize: '16px'
            }
        },

        xAxis: [{
            offset: 0,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e. %b \'%y',
                week: '%e. %b \'%y',
                month: '%b \'%y',
                year: '%y'
            },
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1
        }],

        yAxis: [{
            title: {
                text: ''
            },
            labels: {
                enabled: false
            }
        }],

        legend: {
            layout: 'vertical',
            itemMarginBottom: 4,
            align: 'left',
            x: 0,
            verticalAlign: 'top',
            y: 35,
            floating: true,
            borderWidth: 0,
            labelFormatter: function () {
                var words = this.name.split(/[\s]+/);
                var numWordsPerLine = 3;
                var str = [];
                $('#content').append('<span id="content_string_width"></span>');

                var tempString = [];
                for (var word in words) {
                    tempString.push(words[word]);
                    $('#content_string_width').text(tempString.join(' '));
                    if ($('#content_string_width').width() > 150) {
                        str.push('<br>');
                        tempString = [];
                        tempString.push(words[word]);
                    }


                    str.push(words[word]);
                }
                $('#content_string_width').remove();

                return str.join(' ');
            }
        },

        series: series,

        plotOptions: {
            series: {
                color: '#3276b1',
                pointRange: 24 * 3600 * 1000 // one day
            },
            scatter: {
                marker: {
                    radius: 8,
                    symbol: 'square',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<b>{series.name}</b><br>',
                    pointFormatter: function () {
                        return utils.dateToLocaleString(this.x);
                    }
                }
            }
        }

    });

    addButtonsToChart($('#bacteria_graph'));

    var chart = $('#bacteria_graph').highcharts();
    if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
        chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
    }
}

function addQuestionnaireGraph() {
	var questionnaires = $('[name="questionnaire_types"]').val();
	questionnaires = $.parseJSON(questionnaires);
	var index = 0;

	for (var key in questionnaires)	{
		if (index === 0) {
			$('#' + key).addClass('active');
		}
		index++;
		var data = getSeriesData($('#' + key + '_graph').data().valuesScores)[0];
		var maxScore = $('#' + key + '_graph').data().valuesMaxScore;

		$('#' + key + '_graph').highcharts({

			credits: {
				enabled: false
			},

			chart: {
				type: 'xrange',
				zoomType: 'x',
				marginLeft: 100,
				marginTop: 40,
				height: 750,
				resetZoomButton: {
					theme: {
						display: 'none'
					}
				}
			},

			noData: {
				style: {
					fontWeight: 'normal',
					fontSize: '14px',
					color: '#575757'
				}
			},

			title: {
				text: '',
				style: {
					fontSize: '16px'
				}
			},

			xAxis: [{
				type: 'datetime',
				title: {
					text: trans('tripletrax.date_questionnaires')
				},
				gridLineWidth: 1,
				showFirstLabel: true,
				startOnTick: false
			}],

			yAxis: [{
				min: 0,
				max: maxScore,
				allowDecimals: false,
				title: {
					text: trans('tripletrax.score_value')
				},
				labels: {
					enabled: true
				},
				gridLineWidth: 1
			}],

			tooltip: {
				shared: false,
				// crosshairs: true,
				formatter: function () {
					if (!utils.isUndefined(this.point.x2)) {
						var s = '<b>' + utils.dateToLocaleString(this.x) + ' - ' + utils.dateToLocaleString(this.point.x2) + '</b>';
						s += '<br/>' + this.series.name;

						return s;
					} else {
						var s = '<b>' + utils.dateToLocaleString(this.x) + '</b>';
						s += '<br/>' + this.series.name + ': <b>' + utils.numberToString(this.y) + '</b>';

						return s;
					}
				}
			},

			series: [{
				type: 'line',
				lineWidth: 2,
				marker: {
					enabled: true,
					radius: 4
				},
				name: questionnaires[key],
				data: data,
				color: '#3276b1'
			}]
		});

		addButtonsToChart($('#' + key + '_graph'));

		var chart = $('#' + key + '_graph').highcharts();
		if (moment(chart.xAxis[0].getExtremes().dataMin) < moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y')) {
			chart.xAxis[0].setExtremes(moment(chart.xAxis[0].getExtremes().dataMax).subtract(5, 'y').utc().valueOf(), chart.xAxis[0].getExtremes().dataMax);
		}
	}
}

function addAgeDistributionGraph() {

    var data = $('#age_distribution_graph').data().values;

    $('#age_distribution_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'bar',
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.age_distribution'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: [{
            categories: ['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']
        }],

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value}'
            },
            showFirstLabel: true
        },

        legend: {
            enabled: false
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            formatter: function () {
                var s = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';

                $.each(this.points, function () {
                    s += '<br/>' + trans('tripletrax.number_of_patients') + ': <b>' + utils.numberToString(this.y) + '</b>';
                });

                return s;
            }
        },

        series: [{
            lineWidth: 2,
            marker: {
                enabled: true,
                radius: 4
            },
            data: data,
            name: trans('tripletrax.age_distribution')
        }],

        plotOptions: {
            series: {
                color: '#3276b1'
            },
            bar: {
                dataLabels: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        }
    });

    addButtonsToChart($('#age_distribution_graph'), false);

    var chart = $('#age_distribution_graph').highcharts();
}

function addAgeDistributionYearsGraph() {

    var data = $('#age_distribution_years_graph').data().values;
    var patients = getSeriesIntegerData($('#age_distribution_years_graph_number_patients').data().values);
	var dataMedian = [];

	for (var k = 0; k < data.length; k++) {
		dataMedian.push([data[k][0], data[k][3]]);
	}

	$('#age_distribution_years_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			zoomType: 'x',
			type: 'boxplot'
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.age_distribution_years'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		xAxis: {
			title: {
				text: trans('tripletrax.year')
			},
			labels: {
				format: '{value}'
			},
			showFirstLabel: true
		},

		yAxis: {
			title: {
				text: trans('tripletrax.years_age')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			min: 0
		},

		plotOptions: {
			boxplot: {
				color: '#96bf48',
				fillColor: '#d8d8d8',
				lineWidth: 2,
				medianColor: '#d9534f',
				medianWidth: 3,
				stemColor: '#E2B14A',
				stemDashStyle: 'dot',
				stemWidth: 1,
				whiskerColor: '#3b9ff3',
				whiskerLength: '60%',
				whiskerWidth: 2
			}
		},


		series: [{
            name: trans('tripletrax.age_distribution_years'),
			data: data,
			legendIndex: 0,

			tooltip: {
				shared: true,
				pointFormatter: function () {
					var patient_number = 0;

						for (var i = 0; i < patients[0].length; i++) {
							if (patients[0][i][0] === this.x) {
								patient_number = patients[0][i][1];
							}

						}

						return '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
                            trans('tripletrax.max') + ': ' + this.high + '<br/>' +
                            trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
                            trans('tripletrax.median') + ': ' + this.median + '<br/>' +
					        trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
					        trans('tripletrax.min') + ': ' + this.low + '<br/>' +
					        trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

			}
        },

            {
                type: 'spline',
                name: trans('tripletrax.median'),
                data:  dataMedian,
                lineWidth: 1.5,
				color: '#6e3671',
				legendIndex: 1
            }]

	});


    addButtonsToChart($('#age_distribution_years_graph'), true);

    var chart = $('#age_distribution_years_graph').highcharts()
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addPatientCountYearsGraph() {

    var data = getSeriesIntegerData($('#patient_count_years_graph').data().values);

    $('#patient_count_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'column'
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.patient_distribution'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            showFirstLabel: true
        },

        yAxis: {
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        },

        legend: {
            enabled: false
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            formatter: function () {
                var s = '<b>' + this.x + '</b>';

                $.each(this.points, function () {
                    s += '<br/>' + trans('tripletrax.number_of_patients') + ': <b>' + utils.numberToString(this.y) + '</b>';
                });

                return s;
            }
        },

        series: [{
            data: data[0],
            name: trans('tripletrax.patient_distribution')
        }
		],

        plotOptions: {
            series: {
                color: '#96bf48'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        }
    });

    addButtonsToChart($('#patient_count_years_graph'), true);

    var chart = $('#patient_count_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addLufuFacilityGraph() {

    var data = $('#lufu_facility_graph').data().values;
    var patients = $('#lufu_facility_graph_number_patients').data().values;
	var dataMedian = [];

	for (var k = 0; k < data.length; k++) {
		dataMedian.push(data[k][2]);
	}

    $('#lufu_facility_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'boxplot'
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.lufu'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            categories: ['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
        },

        yAxis: {
            title: {
                text: trans('tripletrax.fev1_percent_norm')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true
        },

        plotOptions: {
            boxplot: {
                color: '#3b9ff3',
                fillColor: '#F0F0E0',
                lineWidth: 2,
                medianColor: '#3276b1',
                medianWidth: 3,
                stemColor: '#d9534f',
                stemDashStyle: 'dot',
                stemWidth: 1,
                whiskerColor: '#96bf48',
                whiskerLength: '60%',
                whiskerWidth: 2
            }
        },

        series: [{
            name: trans('tripletrax.fev1_percent_norm'),
            data: data,
			legendIndex: 0,

			tooltip: {
				shared: true,
				pointFormatter: function () {
					var patient_number = 0;

					for(var key in patients)
					{
						if(key === this.category)
						{
							patient_number = patients[key][0];
						}
					}

					return '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

			}

        },

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
                color: '#F7A00A',
				legendIndex: 1
			}]

    });

    addButtonsToChart($('#lufu_facility_graph'), false);

    var chart = $('#lufu_facility_graph').highcharts();
}

function addLufuFacilityYearsGraph() {

    var data = $('#lufu_facility_years_graph').data().values;
	var patients = $('#lufu_facility_years_graph_number_patients').data().values;
	var dataMedian = [];

	for (var k = 0; k < data.length; k++) {
		dataMedian.push([data[k][0], data[k][3]]);
	}

    $('#lufu_facility_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'boxplot'
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.lufu_years'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            labels: {
                format: '{value}'
            },
            showFirstLabel: true
        },

        yAxis: {
            title: {
                text: trans('tripletrax.fev1_percent_norm')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            min: 0
        },

        plotOptions: {
            boxplot: {
                color: '#96bf48',
                fillColor: '#d8d8d8',
                lineWidth: 2,
                medianColor: '#d9534f',
                medianWidth: 3,
                stemColor: '#E2B14A',
                stemDashStyle: 'dot',
                stemWidth: 1,
                whiskerColor: '#3b9ff3',
                whiskerLength: '60%',
                whiskerWidth: 2
            }

        },

        series: [{
            name: trans('tripletrax.fev1_percent_norm'),
            data: data,
			legendIndex: 0,

			tooltip: {
				shared: true,
				pointFormatter: function () {
					var patient_number = 0;

					for(var key in patients)
                    {
                        if(parseInt(key) === this.x)
                        {
                            patient_number = patients[key][0];
                        }
                    }

					return '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

			}

        },

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
                color:  '#6e3671',
				lineWidth: 1.5,
				legendIndex: 1

			}]

    });

    addButtonsToChart($('#lufu_facility_years_graph'), true);

    var chart = $('#lufu_facility_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addLufuFacilitySeverityYearsGraph() {

	var data = $('#lufu_severity_years_graph').data().values;

	$('#lufu_severity_years_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			type: 'column',
			zoomType: 'x',
			resetZoomButton: {
				theme: {
					display: 'none'
				}
			},
			height: 440
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.severity_fev1'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		xAxis: {
			categories: ['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
		},

		yAxis: {
			min: 0,
			max: 100,
			allowDecimals: false,
			title: {
				text: trans('tripletrax.frequency_percent')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			stackLabels: {
				enabled: false,
				style: {
					enabled: true,
					color: '#6e6e6e',
					style: {
						fontSize: '10px',
						fontWeight: 'bold',
						textOutline: '0px 0px contrast'
					}
				}
			}
		},

		legend: {
			reversed: true
		},

		tooltip: {
			shared: true,
			crosshairs: true,
			borderColor: '#3276b1',
			formatter: function () {
				var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
				for (var i = 0; i < 4; i++) {
					if (!utils.isUndefined(this.points[i])) {
						tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b> (' + trans('tripletrax.patient_number') + ' ' + this.points[i].series.options.composition[$.inArray(this.x, this.points[i].series.xAxis.categories)] + ')';
					}
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.fev1_over_80_percent'),
			data: data[2][0],
			color: '#cbcbcb',
			composition: data[2][1]
		}, {
			name: trans('tripletrax.fev1_40_and_80_percent'),
			data: data[1][0],
			color: '#92A2A8',
			composition: data[1][1]
		}, {
			name: trans('tripletrax.fev1_under_40_percent'),
			data: data[0][0],
			color: '#E2B14A',
			composition: data[0][1]
		}],


		plotOptions: {
			series: {
				stacking: 'normal'
			},
			column: {
				dataLabels: {
					enabled: true,
					allowOverlap: true,
					crop: false,
					overflow: 'none',
					style: {
						color: '#6e6e6e',
						fontSize: '11px',
						fontWeight: 500,
						textOutline: '0'
					},
					formatter: function () {
						if (this.y == 0) {
							return '';
						}
						if (this.color == '#3276b1') {
							return '<span style="color: white">' + this.y + '</span>';
						} else if (this.color == '#d9534f') {
							return '<span style="color: #d8d8d8">' + this.y + '</span>';
						}
						return this.y;
					}
				}
			}
		}
	});

	addButtonsToChart($('#lufu_severity_years_graph'), true);

	var chart = $('#lufu_severity_years_graph').highcharts();

}

function addWeightFacilityGraph() {

    var data = $('#weight_facility_graph').data().values;
    var patients = $('#weight_facility_graph_number_patients').data().values;
	var dataMedian = [];

	for (var k = 0; k < data.length; k++) {
		dataMedian.push(data[k][2]);
	}

    $('#weight_facility_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'boxplot'
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.weight_report'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            categories: ['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
        },

        yAxis: {
            title: {
                text: trans('tripletrax.bmi_percentile')
            },
            labels: {
                format: '{value:.,0f}'
            },

            showFirstLabel: true
        },

        plotOptions: {
            boxplot: {
                color: '#3b9ff3',
                fillColor: '#F0F0E0',
                lineWidth: 2,
                medianColor: '#3276b1',
                medianWidth: 3,
                stemColor: '#d9534f',
                stemDashStyle: 'dot',
                stemWidth: 1,
                whiskerColor: '#96bf48',
                whiskerLength: '60%',
                whiskerWidth: 2
            }
        },

        series: [{
            name: trans('tripletrax.bmi_percentile'),
            data: data,
			legendIndex: 0,

			tooltip: {


				pointFormatter: function () {
					var patient_number = 0;

					for(var key in patients){

						if(key === this.category)
						{
							patient_number = patients[key][0];
						}
					}

					return '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

			}

        },

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				color:  '#F7A00A',
				legendIndex: 1
			}]

    });

    addButtonsToChart($('#weight_facility_graph'), false);

    var chart = $('#weight_facility_graph').highcharts();
}

function addWeightFacilityYearsGraph() {

    var data = $('#weight_facility_years_graph').data().values;
    var patients = $('#weight_facility_years_graph_number_patients').data().values;
	var dataMedian = [];

	for (var k = 0; k < data.length; k++) {
		dataMedian.push([data[k][0], data[k][3]]);
	}

    $('#weight_facility_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'boxplot'
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.weight_years'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            labels: {
                format: '{value}'
            },
            showFirstLabel: true
        },

        yAxis: {
            title: {
                text: trans('tripletrax.bmi_percentile')
            },
            labels: {
                format: '{value:.,0f}'
            },

            showFirstLabel: true,
            min: 0
        },

        plotOptions: {
            boxplot: {
                color: '#96bf48',
                fillColor: '#d8d8d8',
                lineWidth: 2,
                medianColor: '#d9534f',
                medianWidth: 3,
                stemColor: '#E2B14A',
                stemDashStyle: 'dot',
                stemWidth: 1,
                whiskerColor: '#3b9ff3',
                whiskerLength: '60%',
                whiskerWidth: 2
            }
        },

        series: [{
			name: trans('tripletrax.bmi_percentile'),
			data: data,
			legendIndex: 0,

			tooltip: {
				shared: true,
				pointFormatter: function () {
					var patient_number = 0;

					for(var key in patients)
					{
						if(parseInt(key) === this.x)
						{
							patient_number = patients[key][0];
						}
					}

					return '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

			}
		},

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				color: '#6e3671',
				legendIndex: 1
			}]

    });

    addButtonsToChart($('#weight_facility_years_graph'), true);

    var chart = $('#weight_facility_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addComplicationsFacilityGraph() {

    var data = $('#complications_facility_graph').data().values;

    $('#complications_facility_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'column',
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            },
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.complications'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            categories: ['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
                for (var i = 0; i < 4; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.dios'),
            data: data[3],
            color: '#d9534f'
        }, {
            name: trans('tripletrax.abpa'),
            data: data[2],
            color: '#E2B14A'
        }, {
            name: trans('tripletrax.liver_disease'),
            data: data[1],
            color: '#96bf48'
        }, {
            name: trans('tripletrax.diabetes'),
            data: data[0],
            color: '#3276b1'
        }],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1') {
                            return '<span style="color: white">' + this.y + '</span>';
                        } else if (this.color == '#d9534f') {
                            return '<span style="color: #d8d8d8">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#complications_facility_graph'), false);

    var chart = $('#complications_facility_graph').highcharts();
}

function addComplicationsFacilityYearsGraph() {

    var data = $.extend([], $('#complications_facility_years_graph').data().values);

    $('#complications_facility_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'column',
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.complications_years'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            showFirstLabel: true
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + '</b>';
                for (var i = 0; i < 4; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.dios'),
            data: data[3],
            color: '#d9534f'
        }, {
            name: trans('tripletrax.abpa'),
            data: data[2],
            color: '#E2B14A'
        }, {
            name: trans('tripletrax.liver_disease'),
            data: data[1],
            color: '#96bf48'
        }, {
            name: trans('tripletrax.diabetes'),
            data: data[0],
            color: '#3276b1'
        }
           ],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1') {
                            return '<span style="color: white">' + this.y + '</span>';
                        } else if (this.color == '#d9534f') {
                            return '<span style="color: #d8d8d8">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#complications_facility_years_graph'), true);

    var chart = $('#complications_facility_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addTherapyFacilityGraph() {

    var data = $('#therapy_facility_graph').data().values;

    $('#therapy_facility_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'column',
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            },
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.therapy'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            categories: ['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
                for (var i = 0; i < 4; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.ursodeoxycholic_acid'),
            data: data[2],
            color: '#96bf48'
        }, {
            name: trans('tripletrax.pancreatic_enzyme'),
            data: data[1],
            color: '#ac5287'
        }, {
            name: trans('tripletrax.insulin'),
            data: data[0],
            color: '#3276b1'
        }],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1' || this.color == '#ac5287') {
                            return '<span style="color: white">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#therapy_facility_graph'), false);

    var chart = $('#therapy_facility_graph').highcharts();
}

function addTherapyFacilityYearsGraph() {

    var data = $.extend([], $('#therapy_facility_years_graph').data().values);

    $('#therapy_facility_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'column',
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.therapy_years'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            showFirstLabel: true
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + '</b>';
                for (var i = 0; i < 4; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.ursodeoxycholic_acid'),
            data: data[2],
            color: '#96bf48'
        }, {
            name: trans('tripletrax.pancreatic_enzyme'),
            data: data[1],
            color: '#ac5287'
        }, {
            name: trans('tripletrax.insulin'),
            data: data[0],
            color: '#3276b1'
        }],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1' || this.color == '#ac5287') {
                            return '<span style="color: white">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#therapy_facility_years_graph'), true);

    var chart = $('#therapy_facility_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addMibiFacilityGraph() {

    var data = $('#mibi_facility_graph').data().values;

    $('#mibi_facility_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
            type: 'column',
            zoomType: 'x',
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            },
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.mibi'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            categories: ['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
                for (var i = 0; i < 8; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.mrsa'),
            data: data[7],
            color: '#cbcbcb',
            stack: 'main'
        }, {
            name: trans('tripletrax.mrsa_chronic'),
            data: data[6],
            color: '#92A2A8',
            stack: 'main'
        }, {
            name: trans('tripletrax.burkholderia'),
            data: data[5],
            color: '#f7a35c',
            stack: 'main'
        }, {
            name: trans('tripletrax.burkholderia_chronic'),
            data: data[4],
            color: '#d9534f',
            stack: 'main'
        }, {
            name: trans('tripletrax.pseudomonas_not_mdr'),
            data: data[3],
            color: '#a8829f',
            stack: 'detail',
            visible: false
        }, {
            name: trans('tripletrax.pseudomonas_is_mdr'),
            data: data[2],
            color: '#ac5287',
            stack: 'detail',
            visible: false
        }, {
            name: trans('tripletrax.pseudomonas'),
            data: data[1],
            color: '#00a1a3',
            stack: 'main'
        }, {
            name: trans('tripletrax.pseudomonas_chronic'),
            data: data[0],
            color: '#3276b1',
            stack: 'main'
        }],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1' || this.color == '#00a1a3' || this.color == '#d9534f' || this.color == '#a8829f' || this.color == '#ac5287' || this.color == '#92A2A8') {
                            return '<span style="color: white">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#mibi_facility_graph'), false);

    var chart = $('#mibi_facility_graph').highcharts();
}

function addMibiFacilityYearsGraph() {

    var data = $.extend([], $('#mibi_facility_years_graph').data().values);

    $('#mibi_facility_years_graph').highcharts({

        credits: {
            enabled: false
        },

        chart: {
			zoomType: 'x',
            type: 'column',
            height: 440
        },

        noData: {
            style: {
                fontWeight: 'normal',
                fontSize: '14px',
                color: '#575757'
            }
        },

        title: {
            text: trans('tripletrax.mibi_years'),
            margin: 40,
            style: {
                fontSize: '16px'
            }
        },

        xAxis: {
            title: {
                text: trans('tripletrax.year')
            },
            showFirstLabel: true
        },

        yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
                text: trans('tripletrax.number_of_patients')
            },
            labels: {
                format: '{value:.,0f}'
            },
            showFirstLabel: true,
            stackLabels: {
                enabled: false,
                style: {
                    enabled: true,
                    color: '#6e6e6e',
                    style: {
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textOutline: '0px 0px contrast'
                    }
                }
            }
        },

        legend: {
            reversed: true
        },

        tooltip: {
            shared: true,
            crosshairs: true,
            borderColor: '#3276b1',
            formatter: function () {
                var tooltipString = '<b>' + this.x + '</b>';
                for (var i = 0; i < 6; i++) {
                    if (!utils.isUndefined(this.points[i])) {
                        tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
                    }
                }

                return tooltipString;
            }
        },

        series: [{
            name: trans('tripletrax.mrsa'),
            data: data[7],
            color: '#cbcbcb',
            stack: 'main'
        }, {
            name: trans('tripletrax.mrsa_chronic'),
            data: data[6],
            color: '#92A2A8',
            stack: 'main'
        }, {
            name: trans('tripletrax.burkholderia'),
            data: data[5],
            color: '#f7a35c',
            stack: 'main'
        }, {
            name: trans('tripletrax.burkholderia_chronic'),
            data: data[4],
            color: '#d9534f',
            stack: 'main'
        }, {
            name: trans('tripletrax.pseudomonas_not_mdr'),
            data: data[3],
            color: '#a8829f',
            stack: 'detail',
            visible: false
        }, {
            name: trans('tripletrax.pseudomonas_is_mdr'),
            data: data[2],
            color: '#ac5287',
            stack: 'detail',
            visible: false
        }, {
            name: trans('tripletrax.pseudomonas'),
            data: data[1],
            color: '#00a1a3',
            stack: 'main'
        }, {
            name: trans('tripletrax.pseudomonas_chronic'),
            data: data[0],
            color: '#3276b1',
            stack: 'main'
        }],

        plotOptions: {
            series: {
                stacking: 'normal'
            },
            column: {
                dataLabels: {
                    enabled: true,
                    allowOverlap: true,
                    crop: false,
                    overflow: 'none',
                    style: {
                        color: '#6e6e6e',
                        fontSize: '11px',
                        fontWeight: 500,
                        textOutline: '0'
                    },
                    formatter: function () {
                        if (this.y == 0) {
                            return '';
                        }
                        if (this.color == '#3276b1' || this.color == '#00a1a3' || this.color == '#d9534f' || this.color == '#a8829f' || this.color == '#ac5287' || this.color == '#92A2A8') {
                            return '<span style="color: white">' + this.y + '</span>';
                        }
                        return this.y;
                    }
                }
            }
        }
    });

    addButtonsToChart($('#mibi_facility_years_graph'), true);

    var chart = $('#mibi_facility_years_graph').highcharts();
    if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
        chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
    }
}

function addLufuBenchmarkingGraph() {

	var data = $('#lufu_facility_bench_graph').data().values;
	var dataBench = $('#lufu_facility_bench_graph').data().benchValues;
	var patients = $('#lufu_facility_bench_graph_number_patients').data().values;
	var patientsBench = $('#lufu_facility_bench_graph_number_patients').data().benchValues;

	var dataMedian = [];
	var dataMedianBench = [];
	var interval = 0.15;
	for (var k = 0; k < data.length; k++) {
		dataMedian.push([k - interval, data[k][2]]);
	}
	for (var k = 0; k < dataBench.length; k++) {
		dataMedianBench.push([k + interval, dataBench[k][2]]);
	}

	$('#lufu_facility_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			type: 'boxplot'
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.lufu'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		legend: {
			reversed: false
		},

		xAxis: {
			categories: ['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
		},

		yAxis: {
			title: {
				text: trans('tripletrax.fev1_percent_norm')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true
		},

		tooltip: {
			formatter: function () {
				var tooltipString = '<span style="font-size: 10px">' + this.series.xAxis.categories[(this.point.index)] + '</span><br/>';

				if (this.series.options.type === 'spline') {
					tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
				} else {
					var patient_number = 0;

					if (this.series.name === trans('tripletrax.fev1_percent_norm'))
					{
						for(var key in patients) {
							if (key === this.point.category) {
								patient_number = patients[key][0];
							}
						}
					} else {
						for (var key in patientsBench) {
							if (key === this.point.category) {
								patient_number = patientsBench[key][0];
							}
						}
					}

					tooltipString += '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.fev1_percent_norm'),
			data: data,
			color: '#3b9ff3',
			fillColor: '#F0F0E0',
			lineWidth: 2,
			medianColor: '#3276b1',
			medianWidth: 3,
			stemColor: '#d9534f',
			stemDashStyle: 'dot',
			stemWidth: 1,
			whiskerColor: '#96bf48',
			whiskerLength: '60%',
			whiskerWidth: 2,
			legendIndex: 0
		},
			{
				name: trans('tripletrax.fev1_percent_norm_bench'),
				data: dataBench,
				color: '#eac116',
				fillColor: '#F0F0E0',
				lineWidth: 2,
				medianColor: '#d9984f',
				medianWidth: 3,
				stemColor: '#d9534f',
				stemDashStyle: 'dot',
				stemWidth: 1,
				whiskerColor: '#ad2d1c',
				whiskerLength: '60%',
				whiskerWidth: 2,
				legendIndex: 2
			},

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				legendIndex: 1,
				color: '#ad2d1c'
			},
			{
				type: 'spline',
				name: trans('tripletrax.median_bench'),
				data:  dataMedianBench,
				lineWidth: 1.5,
				legendIndex: 3,
				color: '#96bf48'
			}]

	});

	addButtonsToChart($('#lufu_facility_bench_graph'), false);

	var chart = $('#lufu_facility_bench_graph').highcharts();
}

function addLufuBenchmarkingYearsGraph() {

	var data = $('#lufu_facility_years_bench_graph').data().values;
	var dataBench = $('#lufu_facility_years_bench_graph').data().benchValues;
	var patients = $('#lufu_facility_years_bench_graph_number_patients').data().values;
	var patientsBench = $('#lufu_facility_years_bench_graph_number_patients').data().benchValues;

	var dataMedian = [];
	var dataMedianBench = [];
	var interval = 0.15;
	for (var k = 0; k < data.length; k++) {
		dataMedian.push([data[k][0] - interval, data[k][3]]);
	}
	for (var k = 0; k < dataBench.length; k++) {
		dataMedianBench.push([dataBench[k][0] + interval, dataBench[k][3]]);
	}

	$('#lufu_facility_years_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			zoomType: 'x',
			type: 'boxplot'
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.lufu_years'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		legend: {
			reversed: false
		},

		xAxis: {
			title: {
				text: trans('tripletrax.year')
			},
			labels: {
				format: '{value}'
			},
			showFirstLabel: true
		},

		yAxis: {
			title: {
				text: trans('tripletrax.fev1_percent_norm')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			min: 0
		},

		tooltip: {
			formatter: function () {
				var tooltipString = '';

				if (this.series.options.type === 'spline') {
					if (this.series.name === trans('tripletrax.median')) {
						tooltipString = '<span style="font-size: 10px">' + (this.point.x + interval) + '</span><br/>';
					} else {
						tooltipString = '<span style="font-size: 10px">' + (this.point.x - interval) + '</span><br/>';
					}

					tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
				} else {
					tooltipString = '<span style="font-size: 10px">' + this.point.x + '</span><br/>';
					var patient_number = 0;

					if (this.series.name === trans('tripletrax.fev1_percent_norm'))
					{
						for(var key in patients) {
							if (key == this.point.category) {
								patient_number = patients[key][0];
							}
						}
					} else {
						for (var key in patientsBench) {
							if (key == this.point.category) {
								patient_number = patientsBench[key][0];
							}
						}
					}

					tooltipString += '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.fev1_percent_norm'),
			data: data,
			color: '#96bf48',
			fillColor: '#e5e5e5',
			lineWidth: 2,
			medianColor: '#d9534f',
			medianWidth: 3,
			stemColor: '#E2B14A',
			stemDashStyle: 'dot',
			stemWidth: 1,
			whiskerColor: '#3b9ff3',
			whiskerLength: '60%',
			whiskerWidth: 2,
			legendIndex: 0
		},
			{
				name: trans('tripletrax.fev1_percent_norm_bench'),
				data: dataBench,
				color: '#a8829f',
				fillColor: '#e5e5e5',
				lineWidth: 2,
				medianColor: '#306aa1',
				medianWidth: 3,
				stemColor: '#d9534f',
				stemDashStyle: 'dot',
				stemWidth: 1,
				whiskerColor: '#5ba0a3',
				whiskerLength: '60%',
				whiskerWidth: 2,
				legendIndex: 2
			},

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				legendIndex: 1,
				color: '#3b9ff3'
			},
			{
				type: 'spline',
				name: trans('tripletrax.median_bench'),
				data:  dataMedianBench,
				lineWidth: 1.5,
				legendIndex: 3,
				color: '#E2B14A'
			}]

	});

	addButtonsToChart($('#lufu_facility_years_bench_graph'), true);

	var chart = $('#lufu_facility_years_bench_graph').highcharts();
	if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
		chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
	}
}

function addLufuBenchmarkingSeverityYearsGraph() {

	var data = $('#lufu_severity_years_bench_graph').data().values;
	var dataBench = $('#lufu_severity_years_bench_graph').data().benchValues;

	$('#lufu_severity_years_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			type: 'column',
			zoomType: 'x',
			resetZoomButton: {
				theme: {
					display: 'none'
				}
			},
			height: 440
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.severity_fev1'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		xAxis: {
			categories: ['6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
		},

		yAxis: {
			min: 0,
			max: 100,
			allowDecimals: false,
			title: {
				text: trans('tripletrax.frequency_percent')
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			stackLabels: {
				enabled: false,
				style: {
					enabled: true,
					color: '#6e6e6e',
					style: {
						fontSize: '10px',
						fontWeight: 'bold',
						textOutline: '0px 0px contrast'
					}
				}
			}
		},

		legend: {
			reversed: false
		},

		tooltip: {
			shared: true,
			crosshairs: true,
			borderColor: '#3276b1',
			formatter: function () {
				var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
				for (var i = 0; i < 6; i++) {
					if (!utils.isUndefined(this.points[i])) {
						tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b> (' + trans('tripletrax.patient_number') + ' ' + this.points[i].series.options.composition[$.inArray(this.x, this.points[i].series.xAxis.categories)] + ')';
					}
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.fev1_over_80_percent'),
			data: data[2][0],
			color: '#cbcbcb',
			composition: data[2][1],
			stack: 'self',
			legendIndex: 2
		}, {
			name: trans('tripletrax.fev1_40_and_80_percent'),
			data: data[1][0],
			color: '#92A2A8',
			composition: data[1][1],
			stack: 'self',
			legendIndex: 1
		}, {
			name: trans('tripletrax.fev1_under_40_percent'),
			data: data[0][0],
			color: '#E2B14A',
			composition: data[0][1],
			stack: 'self',
			legendIndex: 0
		}, {
			name: trans('tripletrax.fev1_over_80_percent_bench'),
			data: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[2][0],
			color: '#abbed2',
			composition: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[2][1],
			stack: 'bench',
			legendIndex: 5
		}, {
			name: trans('tripletrax.fev1_40_and_80_percent_bench'),
			data: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[1][0],
			color: '#3276b1',
			composition: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[1][1],
			stack: 'bench',
			legendIndex: 4
		}, {
			name: trans('tripletrax.fev1_under_40_percent_bench'),
			data: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[0][0],
			color: '#d9534f',
			composition: utils.isUndefined(dataBench) || dataBench === '' ? null : dataBench[0][1],
			stack: 'bench',
			legendIndex: 3
		}],


		plotOptions: {
			series: {
				stacking: 'normal'
			},
			column: {
				dataLabels: {
					enabled: true,
					allowOverlap: true,
					crop: false,
					overflow: 'none',
					style: {
						color: '#6e6e6e',
						fontSize: '11px',
						fontWeight: 500,
						textOutline: '0'
					},
					formatter: function () {
						if (this.y == 0) {
							return '';
						}
						if (this.color == '#3276b1') {
							return '<span style="color: white">' + this.y + '</span>';
						} else if (this.color == '#d9534f') {
							return '<span style="color: #d8d8d8">' + this.y + '</span>';
						}
						return this.y;
					}
				}
			}
		}
	});

	addButtonsToChart($('#lufu_severity_years_bench_graph'), true);
}

function addWeightBenchmarkingGraph() {

	var data = $('#weight_facility_bench_graph').data().values;
	var patients = $('#weight_facility_bench_graph_number_patients').data().values;
	var dataBench = $('#weight_facility_bench_graph').data().benchValues;
	var patientsBench = $('#weight_facility_bench_graph_number_patients').data().benchValues;

	var dataMedian = [];
	var dataMedianBench = [];
	var interval = 0.15;
	for (var k = 0; k < data.length; k++) {
		dataMedian.push([k - interval, data[k][2]]);
	}
	for (var k = 0; k < dataBench.length; k++) {
		dataMedianBench.push([k + interval, dataBench[k][2]]);
	}

	$('#weight_facility_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			type: 'boxplot'
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.weight_report'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		legend: {
			reversed: false
		},

		xAxis: {
			categories: ['0-1', '2-5', '6-11', '12-17', '18-29', '30-39', '40-49', '>= 50']
		},

		yAxis: {
			title: {
				text: trans('tripletrax.bmi_percentile')
			},
			labels: {
				format: '{value:.,0f}'
			},

			showFirstLabel: true
		},

		tooltip: {
			formatter: function () {
				var tooltipString = '<span style="font-size: 10px">' + this.series.xAxis.categories[(this.point.index)] + '</span><br/>';

				if (this.series.options.type === 'spline') {
					tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
				} else {
					var patient_number = 0;

					if (this.series.name === trans('tripletrax.bmi_percentile'))
					{
						for(var key in patients) {
							if (key == this.point.category) {
								patient_number = patients[key][0];
							}
						}
					} else {
						for (var key in patientsBench) {
							if (key == this.point.category) {
								patient_number = patientsBench[key][0];
							}
						}
					}

					tooltipString += '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.bmi_percentile'),
			data: data,
			color: '#3b9ff3',
			fillColor: '#F0F0E0',
			lineWidth: 2,
			medianColor: '#3276b1',
			medianWidth: 3,
			stemColor: '#d9534f',
			stemDashStyle: 'dot',
			stemWidth: 1,
			whiskerColor: '#96bf48',
			whiskerLength: '60%',
			whiskerWidth: 2,
			legendIndex: 0
		},

			{
				name: trans('tripletrax.bmi_percentile_bench'),
				data: dataBench,
				color: '#eac116',
				fillColor: '#F0F0E0',
				lineWidth: 2,
				medianColor: '#d9984f',
				medianWidth: 3,
				stemColor: '#d9534f',
				stemDashStyle: 'dot',
				stemWidth: 1,
				whiskerColor: '#ad2d1c',
				whiskerLength: '60%',
				whiskerWidth: 2,
				legendIndex: 2
			},

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				legendIndex: 1,
				color: '#ad2d1c'
			},
			{
				type: 'spline',
				name: trans('tripletrax.median_bench'),
				data:  dataMedianBench,
				lineWidth: 1.5,
				legendIndex: 3,
				color: '#96bf48'
			}]

	});

	addButtonsToChart($('#weight_facility_bench_graph'), false);

	var chart = $('#weight_facility_bench_graph').highcharts();
}

function addWeightBenchmarkingYearsGraph() {

	var data = $('#weight_facility_years_bench_graph').data().values;
	var dataBench = $('#weight_facility_years_bench_graph').data().benchValues;
	var patients = $('#weight_facility_years_bench_graph_number_patients').data().values;
	var patientsBench = $('#weight_facility_years_bench_graph_number_patients').data().benchValues;

	var dataMedian = [];
	var dataMedianBench = [];
	var interval = 0.15;
	for (var k = 0; k < data.length; k++) {
		dataMedian.push([data[k][0] - interval, data[k][3]]);
	}
	for (var k = 0; k < dataBench.length; k++) {
		dataMedianBench.push([dataBench[k][0] + interval, dataBench[k][3]]);
	}

	$('#weight_facility_years_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			zoomType: 'x',
			type: 'boxplot'
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.weight_years'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		legend: {
			reversed: false
		},

		xAxis: {
			title: {
				text: trans('tripletrax.year')
			},
			labels: {
				format: '{value}'
			},
			showFirstLabel: true
		},

		yAxis: {
			title: {
				text: trans('tripletrax.bmi_percentile')
			},
			labels: {
				format: '{value:.,0f}'
			},

			showFirstLabel: true,
			min: 0
		},

		tooltip: {
			formatter: function () {
				var tooltipString = '';

				if (this.series.options.type === 'spline') {
					if (this.series.name === trans('tripletrax.median')) {
						tooltipString = '<span style="font-size: 10px">' + (this.point.x + interval) + '</span><br/>';
					} else {
						tooltipString = '<span style="font-size: 10px">' + (this.point.x - interval) + '</span><br/>';
					}

					tooltipString += '<span style="color:' + this.point.color + '">\u25CF</span> ' + this.series.name + ': <b>' + this.point.y + '</b><br/>';
				} else {
					tooltipString = '<span style="font-size: 10px">' + this.point.x + '</span><br/>';
					var patient_number = 0;

					if (this.series.name === trans('tripletrax.bmi_percentile'))
					{
						for(var key in patients) {
							if (key == this.point.category) {
								patient_number = patients[key][0];
							}
						}
					} else {
						for (var key in patientsBench) {
							if (key == this.point.category) {
								patient_number = patientsBench[key][0];
							}
						}
					}

					tooltipString += '<span style="color:' +
						this.series.color + '">\u25CF</span> <b> ' +
						this.series.name + '</b><br/>' +
						trans('tripletrax.max') + ': ' + this.point.high + '<br/>' +
						trans('tripletrax.75_quartile') + ': ' + this.point.q3 + '<br/>' +
						trans('tripletrax.median') + ': ' + this.point.median + '<br/>' +
						trans('tripletrax.25_quartile') + ': ' + this.point.q1 + '<br/>' +
						trans('tripletrax.min') + ': ' + this.point.low + '<br/>' +
						trans('tripletrax.patient_number')+ ': ' + patient_number;
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.bmi_percentile'),
			data: data,
			color: '#96bf48',
			fillColor: '#e5e5e5',
			lineWidth: 2,
			medianColor: '#d9534f',
			medianWidth: 3,
			stemColor: '#E2B14A',
			stemDashStyle: 'dot',
			stemWidth: 1,
			whiskerColor: '#3b9ff3',
			whiskerLength: '60%',
			whiskerWidth: 2,
			legendIndex: 0
		},

			{
				name: trans('tripletrax.bmi_percentile_bench'),
				data: dataBench,
				color: '#a8829f',
				fillColor: '#e5e5e5',
				lineWidth: 2,
				medianColor: '#306aa1',
				medianWidth: 3,
				stemColor: '#d9534f',
				stemDashStyle: 'dot',
				stemWidth: 1,
				whiskerColor: '#5ba0a3',
				whiskerLength: '60%',
				whiskerWidth: 2,
				legendIndex: 2
			},

			{
				type: 'spline',
				name: trans('tripletrax.median'),
				data:  dataMedian,
				lineWidth: 1.5,
				legendIndex: 1,
				color: '#3b9ff3'
			},
			{
				type: 'spline',
				name: trans('tripletrax.median_bench'),
				data:  dataMedianBench,
				lineWidth: 1.5,
				legendIndex: 3,
				color: '#E2B14A'
			}]

	});

	addButtonsToChart($('#weight_facility_years_bench_graph'), true);

	var chart = $('#weight_facility_years_bench_graph').highcharts();
	if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
		chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
	}
}

function addMibiBenchmarkingGraph() {

	var data = $.extend([], $('#mibi_facility_bench_graph').data().values);
	var dataBench = $.extend([], $('#mibi_facility_bench_graph').data().benchValues);

	$('#mibi_facility_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			type: 'column',
			zoomType: 'x',
			resetZoomButton: {
				theme: {
					display: 'none'
				}
			},
			height: 440
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.mibi'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		xAxis: {
			categories: ['0-1', '2-5', '6-11', '12‐17', '18‐29', '30‐39', '40‐49', '>= 50']
		},

		yAxis: {
			min: 0,
			allowDecimals: false,
			title: {
				text: '%'
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			stackLabels: {
				enabled: false,
				style: {
					enabled: true,
					color: '#6e6e6e',
					style: {
						fontSize: '10px',
						fontWeight: 'bold',
						textOutline: '0px 0px contrast'
					}
				}
			}
		},

		legend: {
			reversed: false
		},

		tooltip: {
			shared: true,
			crosshairs: true,
			borderColor: '#3276b1',
			formatter: function () {
				var tooltipString = '<b>' + this.x + ' ' + trans('tripletrax.years_age') + '</b>';
				for (var i = 0; i < 8; i++) {
					if (!utils.isUndefined(this.points[i])) {
						tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
					}
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.pseudomonas'),
			data: data[1],
			color: '#00a1a3',
			stack: 'main'
		}, {
			name: trans('tripletrax.pseudomonas_chronic'),
			data: data[0],
			color: '#3276b1',
			stack: 'main'
		},
			{
				name: trans('tripletrax.pseudomonas_bench'),
				data: dataBench[1],
				color: '#E2B14A',
				stack: 'bench'
			}, {
				name: trans('tripletrax.pseudomonas_chronic_bench'),
				data: dataBench[0],
				color: '#d9534f',
				stack: 'bench'
			}],

		plotOptions: {
			series: {
				stacking: 'normal'
			},
			column: {
				dataLabels: {
					enabled: true,
					allowOverlap: true,
					crop: false,
					overflow: 'none',
					style: {
						color: '#6e6e6e',
						fontSize: '11px',
						fontWeight: 500,
						textOutline: '0'
					},
					formatter: function () {
						if (this.y == 0) {
							return '';
						}
						if (this.color == '#3276b1' || this.color == '#00a1a3' || this.color == '#d9534f' || this.color == '#a8829f' || this.color == '#ac5287' || this.color == '#92A2A8'
							|| this.color == '#E2B14A') {
							return '<span style="color: white">' + this.y + '</span>';
						}
						return this.y;
					}
				}
			}
		}
	});

	addButtonsToChart($('#mibi_facility_bench_graph'), false);

	var chart = $('#mibi_facility_bench_graph').highcharts();
}

function addMibiBenchmarkingYearsGraph() {

	var data = $.extend([], $('#mibi_facility_years_bench_graph').data().values);
	var dataBench = $.extend([], $('#mibi_facility_years_bench_graph').data().benchValues);

	$('#mibi_facility_years_bench_graph').highcharts({

		credits: {
			enabled: false
		},

		chart: {
			zoomType: 'x',
			type: 'column',
			height: 440
		},

		noData: {
			style: {
				fontWeight: 'normal',
				fontSize: '14px',
				color: '#575757'
			}
		},

		title: {
			text: trans('tripletrax.mibi_years'),
			margin: 40,
			style: {
				fontSize: '16px'
			}
		},

		xAxis: {
			title: {
				text: trans('tripletrax.year')
			},
			showFirstLabel: true
		},

		yAxis: {
			min: 0,
			allowDecimals: false,
			title: {
				text: '%'
			},
			labels: {
				format: '{value:.,0f}'
			},
			showFirstLabel: true,
			stackLabels: {
				enabled: false,
				style: {
					enabled: true,
					color: '#6e6e6e',
					style: {
						fontSize: '10px',
						fontWeight: 'bold',
						textOutline: '0px 0px contrast'
					}
				}
			}
		},

		legend: {
			reversed: false
		},

		tooltip: {
			shared: true,
			crosshairs: true,
			borderColor: '#3276b1',
			formatter: function () {
				var tooltipString = '<b>' + this.x + '</b>';
				for (var i = 0; i < 6; i++) {
					if (!utils.isUndefined(this.points[i])) {
						tooltipString += '<br/>' + this.points[i].series.name + ': <b>' + utils.numberToString(this.points[i].y) + '</b>';
					}
				}

				return tooltipString;
			}
		},

		series: [{
			name: trans('tripletrax.pseudomonas'),
			data: data[1],
			color: '#00a1a3',
			stack: 'main'
		}, {
			name: trans('tripletrax.pseudomonas_chronic'),
			data: data[0],
			color: '#3276b1',
			stack: 'main'
		},
			{
			name: trans('tripletrax.pseudomonas_bench'),
			data: dataBench[1],
			color: '#E2B14A',
			stack: 'bench'
		}, {
		name: trans('tripletrax.pseudomonas_chronic_bench'),
			data: dataBench[0],
			color: '#d9534f',
			stack: 'bench'
	}],

		plotOptions: {
			series: {
				stacking: 'normal'
			},
			column: {
				dataLabels: {
					enabled: true,
					allowOverlap: true,
					crop: false,
					overflow: 'none',
					style: {
						color: '#6e6e6e',
						fontSize: '11px',
						fontWeight: 500,
						textOutline: '0'
					},
					formatter: function () {
						if (this.y == 0) {
							return '';
						}
						if (this.color == '#3276b1' || this.color == '#00a1a3' || this.color == '#d9534f' || this.color == '#a8829f' || this.color == '#ac5287' || this.color == '#92A2A8'
							|| this.color == '#E2B14A') {
							return '<span style="color: white">' + this.y + '</span>';
						}
						return this.y;
					}
				}
			}
		}
	});

	addButtonsToChart($('#mibi_facility_years_bench_graph'), true);

	var chart = $('#mibi_facility_years_bench_graph').highcharts();
	if (chart.xAxis[0].getExtremes().dataMin < chart.xAxis[0].getExtremes().dataMax - 9) {
		chart.xAxis[0].setExtremes(chart.xAxis[0].getExtremes().dataMax - 9, chart.xAxis[0].getExtremes().dataMax);
	}
}

function addButtonsToChart(chartElement, addZoomButton) {

    if (utils.isUndefined(addZoomButton)){
        addZoomButton = true;
    }
    var buttonString = '';
    if (addZoomButton) {
        buttonString = '<div class="btn-group pull-right tt-report-button">' +
        '<span class="tt-btn-help tt-report-reset-button" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.reset_zoom') + '">' +
        '<i class="fad fa-search-minus"></i>' +
        '</span>' +
        '</div>';
    }
    buttonString += '<div class="btn-group pull-right tt-report-button">' +
        '<span class="tt-btn-help tt-report-print-button" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.context_button_title') + '">' +
        '<i class="fad fa-print"></i>' +
        '</span>' +
        '</div>';

    chartElement.prepend(
        buttonString
    );

    initialize.initializeElements(chartElement, true, false);
}

function getSeriesData(dataString) {

    var dataArray = [];

    if (!utils.isUndefined(dataString)) {
        var data = dataString.split('|');
        var seriesData = [];

        for (var i = 1; i < data.length; i++) {
            var fields = data[i].split(',');
            for (var k = 1; k < fields.length; k++) {
                if (fields.length > k) {
                    if (dataArray.length > k - 1) {
                        seriesData = dataArray[k - 1];
                    } else {
                        seriesData = [];
                    }
                    if (fields[k] !== '') {
                        seriesData.push([utils.stringToUTCDate(fields[0]), parseFloat(fields[k])]);
                    } else {
                        seriesData.push([utils.stringToUTCDate(fields[0]), null]);
                    }

                    dataArray[k - 1] = seriesData;
                }
            }
        }
    }

    return dataArray;
}

function getSeriesCategoryData(dataString) {

    var dataArray = [];

    if (!utils.isUndefined(dataString)) {
        var data = dataString.split('|');
        var seriesData = [];

        for (var i = 1; i < data.length; i++) {
            var fields = data[i].split(',');
            for (var k = 1; k < fields.length; k++) {
                if (fields.length > k) {
                    if (dataArray.length > k - 1) {
                        seriesData = dataArray[k - 1];
                    } else {
                        seriesData = [];
                    }
                    seriesData.push([fields[0], parseInt(fields[k])]);

                    dataArray[k - 1] = seriesData;
                }
            }
        }
    }

    return dataArray;
}

function getSeriesIntegerData(dataString) {

    var dataArray = [];

    if (!utils.isUndefined(dataString)) {
        var data = dataString.split('|');
        var seriesData = [];

        for (var i = 1; i < data.length; i++) {
            var fields = data[i].split(',');
            for (var k = 1; k < fields.length; k++) {
                if (fields.length > k) {
                    if (dataArray.length > k - 1) {
                        seriesData = dataArray[k - 1];
                    } else {
                        seriesData = [];
                    }
                    seriesData.push([parseInt(fields[0]), parseInt(fields[k])]);

                    dataArray[k - 1] = seriesData;
                }
            }
        }
    }

    return dataArray;
}

function getXRangeSeriesData(dataString) {

    var dataArray = [];
    var data = dataString.split('|');

    // "x":2011-11-16 12:00:00,"x2:"2012-05-10 12:00:00,"y":0
    for (var i = 1; i < data.length; i++) {
        if (data[i] !== '') {
            var fields = data[i].split(',');
            var subDataObj = {};
            for (var k = 0; k < fields.length; k++) {
                var subFields = fields[k].split('=');
                if (k === fields.length - 1) {
                    if (subFields[1] !== '') {
                        subDataObj[subFields[0]] = parseInt(subFields[1]);
                    } else {
                        subDataObj[subFields[0]] = null;
                    }
                } else {
                    subDataObj[subFields[0]] = utils.stringToUTCDate(subFields[1]);
                }
            }
            dataArray.push(subDataObj);
        }
    }

    return dataArray;
}

module.exports.registerReportsEvents = registerReportsEvents;
module.exports.setFacilityChartPage = setFacilityChartPage;
module.exports.setChartPage = setChartPage;
module.exports.reflowCharts = reflowCharts;
